<template>
  <div>
    <!-- Person details &  sentiment -->
    <div class="row mb-2">
      <div class="col-6 mb-2">
        <div class="card h-100">
          <div class="card-body text-left">
            <div class="row">
              <div class="col-sm-4">
                <h5>{{ $t("instagram.basic-info") }}</h5>
              </div>
              <div class="col-sm-8 text-right">
                <router-link
                  :to="'/report-instagram/' + id"
                  target="_blank"
                  class="mr-1"
                >
                  <b-button class="btn btn-sm" variant="light"
                    ><i class="mdi mdi-badge-account-horizontal-outline"></i>
                    {{ $t("instagram.report") }} Instagram</b-button
                  >
                </router-link>
                <b-button
                  class="btn btn-sm"
                  variant="success"
                  @click="updateProfile"
                >
                  <span v-if="loadingupdateprofile"
                    ><b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner
                  ></span>
                  <span v-if="!loadingupdateprofile"
                    ><i class="bx bx-history"></i></span
                ></b-button>
              </div>
            </div>
            <div class="mb-3 mt-4">
              <div class="media">
                <img
                  :src="basicInfo.avatar"
                  class="mr-3 rounded-circle avatar-md"
                  alt="user-pic"
                  v-if="basicInfo.avatar"
                />
                <img
                  src="https://img.icons8.com/ios/240/000000/user-male-circle.png"
                  class="mr-3 rounded-circle avatar-md"
                  alt="user-pic"
                  v-else
                />
                <div class="media-body p-1 text-center">
                  <h6 class="mb-1 text-uppercase">
                    {{ $t("instagram.followers") }}
                  </h6>
                  <hr />
                  <h6>{{ basicInfo.followers }}</h6>
                </div>
                <div class="media-body p-1 text-center">
                  <h6 class="mb-1 text-uppercase">
                    {{ $t("instagram.following") }}
                  </h6>
                  <hr />
                  <h6>{{ basicInfo.following }}</h6>
                </div>
                <div class="media-body p-1 text-center">
                  <h6 class="mb-1 text-uppercase">
                    {{ $t("instagram.post") }}
                  </h6>
                  <hr />
                  <h6>{{ basicInfo.media }}</h6>
                </div>
              </div>
            </div>
            <div>
              <a
                :href="'https://www.instagram.com/' + basicInfo.username"
                target="_blank"
                class="d-flex mb-2"
              >
                <span class="text-primary my-auto">{{ basicInfo.name }}</span>
                <span v-if="basicInfo.is_verified == 1"
                  ><i
                    class="
                      my-auto
                      ml-1
                      text-primary
                      mdi mdi-check-decagram mdi-18px
                    "
                  ></i
                ></span>
              </a>
              <p class="text-secondary mb-3">@{{ basicInfo.username }}</p>

              <span
                v-if="basicInfo.is_private == 1"
                class="text-secondary d-flex align-items-center"
              >
                <i class="text-dark mdi mdi-shield-lock-outline mdi-24px"></i>
                {{ $t("instagram.this") }}
              </span>
              <div v-if="basicInfo.category_name">
                <h6 class="mt-2">{{ $t("instagram.category") }}</h6>
                <p>{{ basicInfo.category_name }}</p>
              </div>
              <h6 class="mt-2">Bio</h6>
              <p>{{ basicInfo.bio }}</p>

              <p>
                <i class="bx bx-calendar"> </i>{{ $t("instagram.updated") }} :
                {{ formatDateRefresh(basicInfo.updated_at) }}
              </p>
              <!-- <p v-if="basicInfo.location"><i class="bx bx-map"> </i>{{basicInfo.location}}</p>
                    <p><i class="bx bx-image"> </i> Media: {{basicInfo.media}}</p>
                    <p><i class="bx bx-like"> </i> Likes: {{basicInfo.likes}}</p>
                    <p><i class="bx bx-user"> </i> Account: <span v-if="basicInfo.verified" class="badge badge-info"> Verified </span><span  class="badge badge-primary" v-else>Not Verified </span></p>
                    <p><i class="bx bx-key"> </i> Privasi: <span v-if="basicInfo.private" class="badge badge-primary"> Private </span><span class="badge badge-success" v-else>Public </span></p>
                    -->
              <!-- <p><i class="bx bx-calendar"> </i> {{ $t('instagram.table.joint-at') }}: {{basicInfo.join_date}}</p> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-6 mb-2">
        <div class="card h-100">
          <div class="card-body text-left">
            <div class="row">
              <div class="col-sm-4">
                <h5>{{ $t("instagram.basic-info") }}</h5>
              </div>
              <div class="col-sm-8 text-right">
                <router-link
                  :to="'/report-instagram/' + id_2"
                  target="_blank"
                  class="mr-1"
                >
                  <b-button class="btn btn-sm" variant="light"
                    ><i class="mdi mdi-badge-account-horizontal-outline"></i>
                    {{ $t("instagram.report") }} Instagram</b-button
                  >
                </router-link>
                <b-button
                  class="btn btn-sm"
                  variant="success"
                  @click="updateProfile"
                >
                  <span v-if="loadingupdateprofile2"
                    ><b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner
                  ></span>
                  <span v-if="!loadingupdateprofile2"
                    ><i class="bx bx-history"></i></span
                ></b-button>
              </div>
            </div>
            <div class="mb-3 mt-4">
              <div class="media">
                <img
                  :src="basicInfo2.avatar"
                  class="mr-3 rounded-circle avatar-md"
                  alt="user-pic"
                  v-if="basicInfo2.avatar"
                />
                <img
                  src="https://img.icons8.com/ios/240/000000/user-male-circle.png"
                  class="mr-3 rounded-circle avatar-md"
                  alt="user-pic"
                  v-else
                />
                <div class="media-body p-1 text-center">
                  <h6 class="mb-1 text-uppercase">
                    {{ $t("instagram.followers") }}
                  </h6>
                  <hr />
                  <h6>{{ basicInfo2.followers }}</h6>
                </div>
                <div class="media-body p-1 text-center">
                  <h6 class="mb-1 text-uppercase">
                    {{ $t("instagram.following") }}
                  </h6>
                  <hr />
                  <h6>{{ basicInfo2.following }}</h6>
                </div>
                <div class="media-body p-1 text-center">
                  <h6 class="mb-1 text-uppercase">
                    {{ $t("instagram.post") }}
                  </h6>
                  <hr />
                  <h6>{{ basicInfo2.media }}</h6>
                </div>
              </div>
            </div>
            <div>
              <a
                :href="'https://www.instagram.com/' + basicInfo2.username"
                target="_blank"
                class="d-flex mb-2"
              >
                <span class="text-primary my-auto">{{ basicInfo2.name }}</span>
                <span v-if="basicInfo2.is_verified == 1"
                  ><i
                    class="
                      my-auto
                      ml-1
                      text-primary
                      mdi mdi-check-decagram mdi-18px
                    "
                  ></i
                ></span>
              </a>
              <p class="text-secondary mb-3">@{{ basicInfo2.username }}</p>

              <span
                v-if="basicInfo2.is_private == 1"
                class="text-secondary d-flex align-items-center"
              >
                <i class="text-dark mdi mdi-shield-lock-outline mdi-24px"></i>
                {{ $t("instagram.this") }}
              </span>
              <div v-if="basicInfo2.category_name">
                <h6 class="mt-2">{{ $t("instagram.category") }}</h6>
                <p>{{ basicInfo2.category_name }}</p>
              </div>
              <h6 class="mt-2">Bio</h6>
              <p>{{ basicInfo2.bio }}</p>

              <p>
                <i class="bx bx-calendar"> </i>{{ $t("instagram.updated") }} :
                {{ formatDateRefresh(basicInfo2.updated_at) }}
              </p>
              <!-- <p v-if="basicInfo.location"><i class="bx bx-map"> </i>{{basicInfo.location}}</p>
                    <p><i class="bx bx-image"> </i> Media: {{basicInfo.media}}</p>
                    <p><i class="bx bx-like"> </i> Likes: {{basicInfo.likes}}</p>
                    <p><i class="bx bx-user"> </i> Account: <span v-if="basicInfo.verified" class="badge badge-info"> Verified </span><span  class="badge badge-primary" v-else>Not Verified </span></p>
                    <p><i class="bx bx-key"> </i> Privasi: <span v-if="basicInfo.private" class="badge badge-primary"> Private </span><span class="badge badge-success" v-else>Public </span></p>
                    -->
              <!-- <p><i class="bx bx-calendar"> </i> {{ $t('instagram.table.joint-at') }}: {{basicInfo.join_date}}</p> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="card h-100">
          <div class="card-body text-left">
            <div class="row">
              <div class="col-sm-5">
                <h5>{{ $t("twitter.twitter-view.sentimen") }}</h5>
              </div>
              <div class="col-sm-7 text-right pr-2">
                <span
                  class="text-secondary btn btn-sm btn-light mr-1 mb-1"
                  v-if="sentiment_created_at"
                  >{{ $t("instagram.update") }}:
                  {{ formatDateRefresh(sentiment_created_at) }}</span
                >
                <b-button
                  class="btn btn-sm mb-1"
                  variant="success"
                  @click="getSentimentAnalysIG"
                >
                  <span v-if="loadingsentimen"
                    ><b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner
                  ></span>
                  <span v-if="!loadingsentimen"
                    ><i class="bx bx-history"></i></span
                ></b-button>
              </div>
            </div>
            <div class="col-sm-12 mb-3 mt-5 text-center">
              <div
                class="col-sm-12 p-5"
                v-if="loadingsentimen && !label_sentiment[0]"
              >
                <div class="text-center loading">
                  <b-spinner label="Loading..."></b-spinner>
                </div>
              </div>
              <div
                class="col-sm-12 pt-4 pb-4"
                v-if="!loadingsentimen && !label_sentiment[0]"
              >
                <div class="text-center text-secondary mt-5 mb-5">
                  {{ $t("all.dnf") }}
                </div>
              </div>
              <div v-if="!loadingsentimen && label_sentiment[0]">
                <apexchart
                  class="apex-charts"
                  dir="ltr"
                  height="340"
                  :series="sentimenOptions.series"
                  :options="{
                    chart: {
                      type: 'pie',
                      height: 340,
                      size: 250,
                    },
                    labels: label_sentiment,
                    colors: color_sentiment,
                    legend: {
                      show: true,
                      position: 'bottom',
                      labels: {
                        colors: '#74788d',
                      },
                    },

                    plotOptions: {
                      pie: {
                        donut: {
                          size: '2%',
                        },
                      },
                    },
                  }"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="card h-100">
          <div class="card-body text-left">
            <div class="row">
              <div class="col-sm-5">
                <h5>{{ $t("twitter.twitter-view.sentimen") }}</h5>
              </div>
              <div class="col-sm-7 text-right pr-2">
                <span
                  class="text-secondary btn btn-sm btn-light mr-1 mb-1"
                  v-if="sentiment_created_at2"
                  >{{ $t("instagram.update") }}:
                  {{ formatDateRefresh(sentiment_created_at2) }}</span
                >
                <b-button
                  class="btn btn-sm mb-1"
                  variant="success"
                  @click="getSentimentAnalysIG2"
                >
                  <span v-if="loadingsentimen2"
                    ><b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner
                  ></span>
                  <span v-if="!loadingsentimen2"
                    ><i class="bx bx-history"></i></span
                ></b-button>
              </div>
            </div>
            <div class="col-sm-12 mb-3 mt-5 text-center">
              <div
                class="col-sm-12 p-5"
                v-if="loadingsentimen2 && !label_sentiment2[0]"
              >
                <div class="text-center loading">
                  <b-spinner label="Loading..."></b-spinner>
                </div>
              </div>
              <div
                class="col-sm-12 pt-4 pb-4"
                v-if="!loadingsentimen2 && !label_sentiment2[0]"
              >
                <div class="text-center text-secondary mt-5 mb-5">
                  {{ $t("all.dnf") }}
                </div>
              </div>
              <div v-if="!loadingsentimen2 && label_sentiment2[0]">
                <apexchart
                  class="apex-charts"
                  dir="ltr"
                  height="340"
                  :series="sentimenOptions2.series"
                  :options="{
                    chart: {
                      type: 'pie',
                      height: 340,
                      size: 250,
                    },
                    labels: label_sentiment2,
                    colors: color_sentiment2,
                    legend: {
                      show: true,
                      position: 'bottom',
                      labels: {
                        colors: '#74788d',
                      },
                    },

                    plotOptions: {
                      pie: {
                        donut: {
                          size: '2%',
                        },
                      },
                    },
                  }"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Heatmap post by time -->
    <div class="row mb-2">
      <div class="col-6">
        <div class="card h-100">
          <div class="row">
            <div class="col-sm-6">
              <h5 class="p-4">{{ $t("instagram.heat-map") }}</h5>
            </div>
            <div class="col-sm-6 text-right px-4 pt-4">
              <span
                class="text-secondary btn btn-sm btn-light mr-1"
                v-if="created_at_heatmap"
                >{{ $t("twitter.updated") }}
                {{ formatDateRefresh(created_at_heatmap) }}</span
              >
            </div>
          </div>
          <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingheatmap">
            <div class="text-center loading mb-3">
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>
          <div
            class="col-sm-12 p-5 mt-5 mb-5"
            v-if="!loadingheatmap && !cek_heatmap"
          >
            <div class="text-center loading mb-3">
              {{ $t("all.dnf") }}
            </div>
          </div>
          <div class="p-4" v-if="!loadingheatmap && cek_heatmap">
            <apexchart
              type="heatmap"
              height="350"
              :options="{
                chart: {
                  height: 350,
                  type: 'heatmap',
                },
                dataLabels: {
                  enabled: false,
                },
                colors: ['#bf151c'],
                theme: {
                    mode: theme, 
                    palette: 'palette1', 
                    monochrome: {
                        enabled: false,
                        color: '#bf151c',
                        shadeTo: theme,
                        shadeIntensity: 0.7
                    },
                },
                title: {
                  text: this.$t('instagram.last-heat-map'),
                  align: 'center',
                },
              }"
              :series="heatmapSeries"
            ></apexchart>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="card h-100">
          <div class="row">
            <div class="col-sm-6">
              <h5 class="p-4">{{ $t("instagram.heat-map") }}</h5>
            </div>
            <div class="col-sm-6 text-right px-4 pt-4">
              <span
                class="text-secondary btn btn-sm btn-light mr-1"
                v-if="created_at_heatmap2"
                >{{ $t("twitter.updated") }}
                {{ formatDateRefresh(created_at_heatmap2) }}</span
              >
            </div>
          </div>
          <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingheatmap2">
            <div class="text-center loading mb-3">
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>
          <div
            class="col-sm-12 p-5 mt-5 mb-5"
            v-if="!loadingheatmap2 && !cek_heatmap2"
          >
            <div class="text-center loading mb-3">
              {{ $t("all.dnf") }}
            </div>
          </div>
          <div class="p-4" v-if="!loadingheatmap2 && cek_heatmap2">
            <apexchart
              type="heatmap"
              height="350"
              :options="{
                chart: {
                  height: 350,
                  type: 'heatmap',
                },
                dataLabels: {
                  enabled: false,
                },
                colors: ['#bf151c'],
                theme: {
                    mode: theme, 
                    palette: 'palette1', 
                    monochrome: {
                        enabled: false,
                        color: '#bf151c',
                        shadeTo: theme,
                        shadeIntensity: 0.7
                    },
                },
                title: {
                  text: this.$t('instagram.last-heat-map'),
                  align: 'center',
                },
              }"
              :series="heatmapSeries2"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>

    <!-- recent Post  -->
    <div class="row mt-2 mb-2">
      <div class="col-6">
        <div class="card">
          <div class="row">
            <div class="col-sm-6">
              <h5 class="pt-4 px-4">{{ $t("instagram.recent-post") }}</h5>
            </div>
            <div class="col-sm-6 pt-4 text-right pr-3">
              <span
                class="text-secondary btn btn-sm btn-light mr-1"
                v-if="timeline_created_at"
                >{{ $t("instagram.updated") }}:
                {{ formatDateRefresh(timeline_created_at) }}</span
              >
              <b-button
                class="btn btn-sm mr-3"
                variant="success"
                @click="getTimelineInstaRapid"
              >
                <span v-if="loadingupdatetimeline"
                  ><b-spinner
                    label="Loading ..."
                    small
                    class="p-0 mb-1"
                    style="width: 0.6rem; height: 0.6rem"
                  ></b-spinner
                ></span>
                <span v-if="!loadingupdatetimeline"
                  ><i class="bx bx-history"></i></span
              ></b-button>
            </div>
          </div>

          <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingtimeline">
            <div class="text-center loading">
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>
          <div
            class="col-sm-12 p-5 mt-5 mb-5"
            v-if="!loadingtimeline && !tableData[0]"
          >
            <div class="text-center loading">
              {{ $t("all.dnf") }}
            </div>
          </div>
          <div class="col-sm-12">
            <div id="map" class="mt-4 px-2">
              <GmapMap
                ref="mymap"
                :center="center"
                :zoom="zoom"
                style="height: 50vh"
              >
                <GmapMarker
                  v-for="(m, index) in location_coor"
                  :key="index"
                  :position="{
                    lat: parseFloat(m.lat),
                    lng: parseFloat(m.long),
                  }"
                  :icon="{
                    url: 'https://img.icons8.com/fluency/35/000000/twitter.png',
                    width: 35,
                    height: 35,
                    anchor: { x: 5, y: 25 },
                  }"
                  @click="openMarker(index)"
                >
                  <gmap-info-window
                    :opened="openedMarkerID === index"
                    @closeclick="openMarker(null)"
                  >
                    <div class="p-2">
                      <h5>Date : {{ formatDate(m.content.date) }}</h5>
                      <p class="mt-2" style="width: 200px">
                        {{ m.content.caption }}
                      </p>
                    </div>
                  </gmap-info-window>
                </GmapMarker>
              </GmapMap>
            </div>
          </div>
          <div class="card-body" v-if="!loadingtimeline && tableData[0]">
            <div class="row mt-0 mb-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.show") }}&nbsp;&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      class="mx-1"
                    ></b-form-select
                    >&nbsp;&nbsp;{{ $t("all.entries") }}
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.search") }}:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      :placeholder="$t('all.search')"
                      class="form-control form-control ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fieldsTimeline"
                bordered
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
                <template #cell(taken_at)="row">
                  <span class="text-secondary"
                    >{{ formatDay(row.item.taken_at) }} <br />{{
                      formatDate(row.item.taken_at)
                    }}</span
                  >
                </template>
                <template #cell(actions)="row">
                  <a
                    :href="'https://www.instagram.com/p/' + row.item.code + '/'"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <b-button class="mr-2 btn-sm" variant="primary">
                      <i class="bx bx-show-alt"></i> </b-button
                  ></a>
                </template>
              </b-table>
            </div>
            <div class="col-sm-12 pt-4" v-if="loading && !tableData">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
            <div class="col-sm-12 pt-4" v-if="loadingupdatetimeline">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
            <div
              class="col-sm-12 p-5"
              v-if="tableData == '' && !loadingupdatetimeline"
            >
              <div class="text-center text-secondary mt-5">
                <center>
                  <h5>{{ $t("all.dnf") }}</h5>
                </center>
              </div>
            </div>
            <div class="row" v-if="tableData[0]">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="card">
          <div class="row">
            <div class="col-sm-6">
              <h5 class="pt-4 px-4">{{ $t("instagram.recent-post") }}</h5>
            </div>
            <div class="col-sm-6 pt-4 text-right pr-3">
              <span
                class="text-secondary btn btn-sm btn-light mr-1"
                v-if="timeline_created_at2"
                >{{ $t("instagram.updated") }}:
                {{ formatDateRefresh(timeline_created_at2) }}</span
              >
              <b-button
                class="btn btn-sm mr-3"
                variant="success"
                @click="getTimelineInstaRapid2"
              >
                <span v-if="loadingupdatetimeline2"
                  ><b-spinner
                    label="Loading ..."
                    small
                    class="p-0 mb-1"
                    style="width: 0.6rem; height: 0.6rem"
                  ></b-spinner
                ></span>
                <span v-if="!loadingupdatetimeline2"
                  ><i class="bx bx-history"></i></span
              ></b-button>
            </div>
          </div>

          <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingtimeline2">
            <div class="text-center loading">
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>
          <div
            class="col-sm-12 p-5 mt-5 mb-5"
            v-if="!loadingtimeline2 && !tableData2[0]"
          >
            <div class="text-center loading">
              {{ $t("all.dnf") }}
            </div>
          </div>
          <div class="col-sm-12">
            <div id="map" class="mt-4 px-2">
              <GmapMap
                ref="mymap"
                :center="center2"
                :zoom="zoom2"
                style="height: 50vh"
              >
                <GmapMarker
                  v-for="(m, index) in location_coor2"
                  :key="index"
                  :position="{
                    lat: parseFloat(m.lat),
                    lng: parseFloat(m.long),
                  }"
                  :icon="{
                    url: 'https://img.icons8.com/fluency/35/000000/twitter.png',
                    width: 35,
                    height: 35,
                    anchor: { x: 5, y: 25 },
                  }"
                  @click="openMarker2(index)"
                >
                  <gmap-info-window
                    :opened="openedMarkerID2 === index"
                    @closeclick="openMarker2(null)"
                  >
                    <div class="p-2">
                      <h5>Date : {{ formatDate(m.content.date) }}</h5>
                      <p class="mt-2" style="width: 200px">
                        {{ m.content.caption }}
                      </p>
                    </div>
                  </gmap-info-window>
                </GmapMarker>
              </GmapMap>
            </div>
          </div>
          <div class="card-body" v-if="!loadingtimeline2 && tableData2[0]">
            <div class="row mt-0 mb-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.show") }}&nbsp;&nbsp;
                    <b-form-select
                      v-model="perPage2"
                      size="sm"
                      :options="pageOptions2"
                      class="mx-1"
                    ></b-form-select
                    >&nbsp;&nbsp;{{ $t("all.entries") }}
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.search") }}:
                    <b-form-input
                      v-model="filter2"
                      type="search"
                      :placeholder="$t('all.search')"
                      class="form-control form-control ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData2"
                :fields="fieldsTimeline2"
                bordered
                responsive="sm"
                :per-page="perPage2"
                :current-page="currentPage2"
                :sort-by.sync="sortBy2"
                :sort-desc.sync="sortDesc2"
                :filter="filter2"
                :filter-included-fields="filterOn2"
              >
                <template #cell(taken_at)="row">
                  <span class="text-secondary"
                    >{{ formatDay(row.item.taken_at) }} <br />{{
                      formatDate(row.item.taken_at)
                    }}</span
                  >
                </template>
                <template #cell(actions)="row">
                  <a
                    :href="'https://www.instagram.com/p/' + row.item.code + '/'"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <b-button class="mr-2 btn-sm" variant="primary">
                      <i class="bx bx-show-alt"></i> </b-button
                  ></a>
                </template>
              </b-table>
            </div>
            <div class="col-sm-12 pt-4" v-if="loading2 && !tableData2">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
            <div class="col-sm-12 pt-4" v-if="loadingupdatetimeline2">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
            <div
              class="col-sm-12 p-5"
              v-if="tableData2 == '' && !loadingupdatetimeline2"
            >
              <div class="text-center text-secondary mt-5">
                <center>
                  <h5>{{ $t("all.dnf") }}</h5>
                </center>
              </div>
            </div>
            <div class="row" v-if="tableData2[0]">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage2"
                      :total-rows="rows2"
                      :per-page="perPage2"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- User Tags Post  -->
    <div class="row mt-2 mb-2">
      <div class="col-6">
        <div class="card h-100">
          <div class="row">
            <div class="col-sm-6">
              <h5 class="pt-4 px-4">{{ $t("instagram.user-tags") }}</h5>
            </div>
            <div class="col-sm-6 pt-4 text-right pr-3">
              <span
                class="text-secondary btn btn-sm btn-light mr-1"
                v-if="usertag_created_at"
                >{{ $t("instagram.updated") }}:
                {{ formatDateRefresh(usertag_created_at) }}</span
              >
              <b-button
                class="btn btn-sm mr-3"
                variant="success"
                @click="getUserTagInstaRapid"
              >
                <span v-if="loadingupdateusertag"
                  ><b-spinner
                    label="Loading ..."
                    small
                    class="p-0 mb-1"
                    style="width: 0.6rem; height: 0.6rem"
                  ></b-spinner
                ></span>
                <span v-if="!loadingupdateusertag"
                  ><i class="bx bx-history"></i></span
              ></b-button>
            </div>
          </div>

          <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingtag">
            <div class="text-center loading">
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>
          <div
            class="col-sm-12 p-5 mt-5 mb-5"
            v-if="!loadingtag && !tableDataTags[0]"
          >
            <div class="text-center loading">
              {{ $t("all.dnf") }}
            </div>
          </div>
          <div class="card-body" v-if="!loadingtag && tableDataTags[0]">
            <div class="row mt-0 mb-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.show") }}&nbsp;&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      class="mx-1"
                    ></b-form-select
                    >&nbsp;&nbsp;{{ $t("all.entries") }}
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.search") }}:
                    <b-form-input
                      size="sm"
                      v-model="filterTags"
                      type="search"
                      :placeholder="$t('all.search')"
                      class="form-control form-control ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->

            <div class="table-responsive mb-0">
              <b-table
                :items="tableDataTags"
                :fields="fieldsUserTags"
                bordered
                responsive="sm"
                :per-page="perPageTags"
                :current-page="currentPageTags"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filterTags"
                :filter-included-fields="filterOn"
              >
                <template #cell(taken_at)="row">
                  <span class="text-secondary"
                    >{{ formatDay(row.item.taken_at) }} <br />{{
                      formatDate(row.item.taken_at)
                    }}</span
                  >
                </template>
                <template #cell(actions)="row">
                  <a
                    :href="row.item.link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <b-button class="mr-2 btn-sm" variant="primary">
                      <i class="bx bx-show-alt"></i> </b-button
                  ></a>
                </template>
                <template #cell(username)="row">
                  <a
                    :href="
                      'https://www.instagram.com/' + row.item.screen_name + '/'
                    "
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ row.item.screen_name }}</a
                  >
                </template>
                <template #cell(caption)="row">
                  <a
                    :href="row.item.link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <b-button class="mr-2 btn-sm" variant="primary">
                      <i class="bx bx-show-alt"></i> </b-button
                  ></a>
                </template>
              </b-table>
            </div>
            <div class="row" v-if="rowsTags > 10">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPageTags"
                      :total-rows="rowsTags"
                      :per-page="perPageTags"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="card h-100">
          <div class="row">
            <div class="col-sm-6">
              <h5 class="pt-4 px-4">{{ $t("instagram.user-tags") }}</h5>
            </div>
            <div class="col-sm-6 pt-4 text-right pr-3">
              <span
                class="text-secondary btn btn-sm btn-light mr-1"
                v-if="usertag_created_at2"
                >{{ $t("instagram.updated") }}:
                {{ formatDateRefresh(usertag_created_at2) }}</span
              >
              <b-button
                class="btn btn-sm mr-3"
                variant="success"
                @click="getUserTagInstaRapid2"
              >
                <span v-if="loadingupdateusertag2"
                  ><b-spinner
                    label="Loading ..."
                    small
                    class="p-0 mb-1"
                    style="width: 0.6rem; height: 0.6rem"
                  ></b-spinner
                ></span>
                <span v-if="!loadingupdateusertag2"
                  ><i class="bx bx-history"></i></span
              ></b-button>
            </div>
          </div>

          <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingtag2">
            <div class="text-center loading">
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>
          <div
            class="col-sm-12 p-5 mt-5 mb-5"
            v-if="!loadingtag2 && !tableDataTags2[0]"
          >
            <div class="text-center loading">
              {{ $t("all.dnf") }}
            </div>
          </div>
          <div class="card-body" v-if="!loadingtag2 && tableDataTags2[0]">
            <div class="row mt-0 mb-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.show") }}&nbsp;&nbsp;
                    <b-form-select
                      v-model="perPage2"
                      size="sm"
                      :options="pageOptions2"
                      class="mx-1"
                    ></b-form-select
                    >&nbsp;&nbsp;{{ $t("all.entries") }}
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.search") }}:
                    <b-form-input
                      size="sm"
                      v-model="filterTags2"
                      type="search"
                      :placeholder="$t('all.search')"
                      class="form-control form-control ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->

            <div class="table-responsive mb-0">
              <b-table
                :items="tableDataTags2"
                :fields="fieldsUserTags2"
                bordered
                responsive="sm"
                :per-page="perPageTags2"
                :current-page="currentPageTags2"
                :sort-by.sync="sortBy2"
                :sort-desc.sync="sortDesc2"
                :filter="filterTags2"
                :filter-included-fields="filterOn2"
              >
                <template #cell(taken_at)="row">
                  <span class="text-secondary"
                    >{{ formatDay(row.item.taken_at) }} <br />{{
                      formatDate(row.item.taken_at)
                    }}</span
                  >
                </template>
                <template #cell(actions)="row">
                  <a
                    :href="row.item.link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <b-button class="mr-2 btn-sm" variant="primary">
                      <i class="bx bx-show-alt"></i> </b-button
                  ></a>
                </template>
                <template #cell(username)="row">
                  <a
                    :href="
                      'https://www.instagram.com/' + row.item.screen_name + '/'
                    "
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ row.item.screen_name }}</a
                  >
                </template>
              </b-table>
            </div>
            <div class="row" v-if="rowsTags > 10">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPageTags2"
                      :total-rows="rowsTags2"
                      :per-page="perPageTags2"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Similiar Account top 5 -->
    <div class="row mt-2 mb-2">
      <div class="col-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-4">
                <h5>Similiar Account</h5>
              </div>
              <div class="col-sm-8 text-right pr-2">
                <span
                  class="text-secondary btn btn-sm btn-light mr-1"
                  v-if="similiar_created_at"
                  >{{ $t("all.updated") }}:
                  {{ formatDateRefresh(similiar_created_at) }}</span
                >
                <b-button
                  class="btn btn-sm mr-1"
                  variant="success"
                  @click="getSimiliarAccount"
                >
                  <span v-if="loadingSimiliar"
                    ><b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner>
                  </span>
                  <span v-if="!loadingSimiliar"
                    ><i class="bx bx-history"></i></span
                ></b-button>
              </div>
            </div>
            <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingSimiliar">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
            <div
              class="col-sm-12 p-5 mt-5 mb-5"
              v-if="!loadingSimiliar && !tableDataSimiliar[0]"
            >
              <div class="text-center loading">
                {{ $t("all.dnf") }}
              </div>
            </div>
            <div
              class="table-responsive mb-0 mt-3"
              v-if="!loadingSimiliar && tableDataSimiliar[0]"
            >
              <b-table
                :items="tableDataSimiliar"
                :fields="fieldsSimiliar"
                bordered
                responsive="sm"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filterSimiliar"
              >
                <template #cell(username)="row">
                  <span class="text-secondary">
                    <a
                      :href="'https://www.instagram.com/' + row.item.username"
                      target="_blank"
                      rel="noopener noreferrer"
                      >{{ row.item.username }}</a
                    >
                  </span>
                </template>
                <template #cell(is_private)="row">
                  <span v-if="row.item.is_private" class="text-secondary">
                    <i
                      class="text-dark mdi mdi-shield-lock-outline mdi-24px"
                    ></i>
                  </span>
                  <span v-else class="text-secondary"> - </span>
                </template>
                <template #cell(is_verified)="row">
                  <span v-if="row.item.is_verified" class="text-secondary">
                    <i
                      class="
                        my-auto
                        ml-1
                        text-primary
                        mdi mdi-check-decagram mdi-18px
                      "
                    ></i>
                  </span>
                  <span v-else class="text-secondary"> - </span>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-4">
                <h5>Similiar Account</h5>
              </div>
              <div class="col-sm-8 text-right pr-2">
                <span
                  class="text-secondary btn btn-sm btn-light mr-1"
                  v-if="similiar_created_at2"
                  >{{ $t("all.updated") }}:
                  {{ formatDateRefresh(similiar_created_at2) }}</span
                >
                <b-button
                  class="btn btn-sm mr-1"
                  variant="success"
                  @click="getSimiliarAccount2"
                >
                  <span v-if="loadingSimiliar2"
                    ><b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner>
                  </span>
                  <span v-if="!loadingSimiliar2"
                    ><i class="bx bx-history"></i></span
                ></b-button>
              </div>
            </div>
            <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingSimiliar2">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
            <div
              class="col-sm-12 p-5 mt-5 mb-5"
              v-if="!loadingSimiliar2 && !tableDataSimiliar2[0]"
            >
              <div class="text-center loading">
                {{ $t("all.dnf") }}
              </div>
            </div>
            <div
              class="table-responsive mb-0 mt-3"
              v-if="!loadingSimiliar2 && tableDataSimiliar2[0]"
            >
              <b-table
                :items="tableDataSimiliar2"
                :fields="fieldsSimiliar2"
                bordered
                responsive="sm"
                :sort-by.sync="sortBy2"
                :sort-desc.sync="sortDesc2"
                :filter="filterSimiliar2"
              >
                <template #cell(username)="row">
                  <span class="text-secondary">
                    <a
                      :href="'https://www.instagram.com/' + row.item.username"
                      target="_blank"
                      rel="noopener noreferrer"
                      >{{ row.item.username }}</a
                    >
                  </span>
                </template>
                <template #cell(is_private)="row">
                  <span v-if="row.item.is_private" class="text-secondary">
                    <i
                      class="text-dark mdi mdi-shield-lock-outline mdi-24px"
                    ></i>
                  </span>
                  <span v-else class="text-secondary"> - </span>
                </template>
                <template #cell(is_verified)="row">
                  <span v-if="row.item.is_verified" class="text-secondary">
                    <i
                      class="
                        my-auto
                        ml-1
                        text-primary
                        mdi mdi-check-decagram mdi-18px
                      "
                    ></i>
                  </span>
                  <span v-else class="text-secondary"> - </span>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Followers Following top 5 -->
    <div class="row mt-2 mb-2">
      <div class="col-6 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-4">
                <h5>Last 10 {{ $t("instagram.following") }}</h5>
              </div>
              <div class="col-sm-8 text-right pr-2">
                <span
                  class="text-secondary btn btn-sm btn-light mr-1"
                  v-if="following_created_at"
                  >{{ $t("all.updated") }}:
                  {{ formatDateRefresh(following_created_at) }}</span
                >
                <b-button
                  class="btn btn-sm mr-1"
                  variant="success"
                  @click="getFollowingIGRapid"
                >
                  <span v-if="loadingfollowing"
                    ><b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner>
                  </span>
                  <span v-if="!loadingfollowing"
                    ><i class="bx bx-history"></i></span
                ></b-button>
              </div>
            </div>
            <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingfollowing">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
            <div
              class="col-sm-12 p-5 mt-5 mb-5"
              v-if="!loadingfollowing && !tableDataFollowing[0]"
            >
              <div class="text-center loading">
                {{ $t("all.dnf") }}
              </div>
            </div>
            <div
              class="table-responsive mb-0 mt-3"
              v-if="!loadingfollowing && tableDataFollowing[0]"
            >
              <b-table
                :items="tableDataFollowing"
                :fields="fieldsFollowing"
                bordered
                responsive="sm"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filterFollowing"
              >
                <template #cell(date_time)="row">
                  <span class="text-secondary">{{
                    formatDate(row.item.taken_at)
                  }}</span>
                </template>
                <template #cell(actions)="row">
                  <a
                    :href="row.item.link"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Show"
                  >
                    <b-button class="mr-2 btn-sm" variant="primary">
                      <i class="fas fa-eye"></i> </b-button
                  ></a>
                </template>
                <template #cell(username)="row">
                  <a
                    :href="
                      'https://www.instagram.com/' + row.item.username + '/'
                    "
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ row.item.username }}</a
                  >
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6 mb-2">
        <div class="card h-100">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-4">
                <h5>Last 10 {{ $t("instagram.following") }}</h5>
              </div>
              <div class="col-sm-8 text-right pr-2">
                <span
                  class="text-secondary btn btn-sm btn-light mr-1"
                  v-if="following_created_at2"
                  >{{ $t("all.updated") }}:
                  {{ formatDateRefresh(following_created_at2) }}</span
                >
                <b-button
                  class="btn btn-sm mr-1"
                  variant="success"
                  @click="getFollowingIGRapid2"
                >
                  <span v-if="loadingfollowing2"
                    ><b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner>
                  </span>
                  <span v-if="!loadingfollowing2"
                    ><i class="bx bx-history"></i></span
                ></b-button>
              </div>
            </div>
            <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingfollowing2">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
            <div
              class="col-sm-12 p-5 mt-5 mb-5"
              v-if="!loadingfollowing2 && !tableDataFollowing2[0]"
            >
              <div class="text-center loading">
                {{ $t("all.dnf") }}
              </div>
            </div>
            <div
              class="table-responsive mb-0 mt-3"
              v-if="!loadingfollowing2 && tableDataFollowing2[0]"
            >
              <b-table
                :items="tableDataFollowing2"
                :fields="fieldsFollowing2"
                bordered
                responsive="sm"
                :sort-by.sync="sortBy2"
                :sort-desc.sync="sortDesc2"
                :filter="filterFollowing2"
              >
                <template #cell(date_time)="row">
                  <span class="text-secondary">{{
                    formatDate(row.item.taken_at)
                  }}</span>
                </template>
                <template #cell(actions)="row">
                  <a
                    :href="row.item.link"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Show"
                  >
                    <b-button class="mr-2 btn-sm" variant="primary">
                      <i class="fas fa-eye"></i> </b-button
                  ></a>
                </template>
                <template #cell(username)="row">
                  <a
                    :href="
                      'https://www.instagram.com/' + row.item.username + '/'
                    "
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ row.item.username }}</a
                  >
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-4">
                <h5>Last 10 {{ $t("instagram.followers") }}</h5>
              </div>
              <div class="col-sm-8 text-right pr-2">
                <span
                  class="text-secondary btn btn-sm btn-light mr-1"
                  v-if="followers_created_at"
                  >{{ $t("all.updated") }}:
                  {{ formatDateRefresh(followers_created_at) }}</span
                >
                <b-button
                  class="btn btn-sm mr-1"
                  variant="success"
                  @click="getFollowersIGRapid"
                >
                  <span v-if="loadingfollowers"
                    ><b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner
                  ></span>
                  <span v-if="!loadingfollowers"
                    ><i class="bx bx-history"></i></span
                ></b-button>
              </div>
            </div>

            <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingfollowers">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
            <div
              class="col-sm-12 p-5 mt-5 mb-5"
              v-if="!loadingfollowers && !tableDataFollowers[0]"
            >
              <div class="text-center loading">
                {{ $t("all.dnf") }}
              </div>
            </div>
            <div
              class="table-responsive mb-0 mt-3"
              v-if="!loadingfollowers && tableDataFollowers[0]"
            >
              <b-table
                :items="tableDataFollowers"
                :fields="fieldsFollowers"
                bordered
                responsive="sm"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filterFollowers"
              >
                <template #cell(date_time)="row">
                  <span class="text-secondary">{{
                    formatDate(row.item.taken_at)
                  }}</span>
                </template>
                <template #cell(actions)="row">
                  <a
                    :href="row.item.link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <b-button class="mr-2 btn-sm" variant="primary">
                      <i class="fas fa-eye"></i> </b-button
                  ></a>
                </template>
                <template #cell(username)="row">
                  <a
                    :href="
                      'https://www.instagram.com/' + row.item.username + '/'
                    "
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ row.item.username }}</a
                  >
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-4">
                <h5>Last 10 {{ $t("instagram.followers") }}</h5>
              </div>
              <div class="col-sm-8 text-right pr-2">
                <span
                  class="text-secondary btn btn-sm btn-light mr-1"
                  v-if="followers_created_at2"
                  >{{ $t("all.updated") }}:
                  {{ formatDateRefresh(followers_created_at2) }}</span
                >
                <b-button
                  class="btn btn-sm mr-1"
                  variant="success"
                  @click="getFollowersIGRapid2"
                >
                  <span v-if="loadingfollowers2"
                    ><b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner
                  ></span>
                  <span v-if="!loadingfollowers2"
                    ><i class="bx bx-history"></i></span
                ></b-button>
              </div>
            </div>

            <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingfollowers2">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
            <div
              class="col-sm-12 p-5 mt-5 mb-5"
              v-if="!loadingfollowers2 && !tableDataFollowers2[0]"
            >
              <div class="text-center loading">
                {{ $t("all.dnf") }}
              </div>
            </div>
            <div
              class="table-responsive mb-0 mt-3"
              v-if="!loadingfollowers2 && tableDataFollowers2[0]"
            >
              <b-table
                :items="tableDataFollowers2"
                :fields="fieldsFollowers2"
                bordered
                responsive="sm"
                :sort-by.sync="sortBy2"
                :sort-desc.sync="sortDesc2"
                :filter="filterFollowers2"
              >
                <template #cell(date_time)="row">
                  <span class="text-secondary">{{
                    formatDate(row.item.taken_at)
                  }}</span>
                </template>
                <template #cell(actions)="row">
                  <a
                    :href="row.item.link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <b-button class="mr-2 btn-sm" variant="primary">
                      <i class="fas fa-eye"></i> </b-button
                  ></a>
                </template>
                <template #cell(username)="row">
                  <a
                    :href="
                      'https://www.instagram.com/' + row.item.username + '/'
                    "
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ row.item.username }}</a
                  >
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Word Cloud -->
    <div class="row mb-4">
      <div class="col-6">
        <div class="card h-100">
          <div class="card-body text-left">
            <div class="row">
              <div class="col-sm-6">
                <h5>{{ $t("twitter.twitter-view.word-cloud") }}</h5>
              </div>
              <div class="col-sm-6 text-right pr-3">
                <span
                  class="text-secondary btn btn-sm btn-light mr-1"
                  v-if="wordcloud_created_at"
                  >{{ $t("all.updated") }}:
                  {{ formatDateRefresh(wordcloud_created_at) }}</span
                >
                <b-button
                  class="btn btn-sm"
                  variant="success"
                  @click="getWordCloudIG"
                >
                  <span v-if="loadingword"
                    ><b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner
                  ></span>
                  <span v-if="!loadingword"><i class="bx bx-history"></i></span
                ></b-button>
              </div>
            </div>
            <div>
              <div class="text-center p-5">
                <div
                  class="col-sm-12 p-5 mb-5 pb-5"
                  v-if="loadingword && !wordCloud[0]"
                >
                  <div class="text-center loading">
                    <b-spinner label="Loading..."></b-spinner>
                  </div>
                </div>
                <div
                  class="col-sm-12 pt-5 mb-5"
                  v-if="!wordCloud[0] && !loadingword"
                >
                  <div class="text-center text-secondary mt-5 pb-5">
                    {{ $t("all.dnf") }}
                  </div>
                </div>
                <div v-if="wordCloud[0] && !loadingword">
                  <vue-word-cloud
                    style="
                      height: 480px;
                      width: 100%;
                      font-family: arial, sans-serif;
                    "
                    :words="wordCloud"
                    :color="
                      ([, weight]) =>
                        weight > 10
                          ? '#7f1d1d'
                          : weight > 5
                          ? '#a80a0a'
                          : '#d10404'
                    "
                    font-family="Poppins, sans-serif"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="card h-100">
          <div class="card-body text-left">
            <div class="row">
              <div class="col-sm-6">
                <h5>{{ $t("twitter.twitter-view.word-cloud") }}</h5>
              </div>
              <div class="col-sm-6 text-right pr-3">
                <span
                  class="text-secondary btn btn-sm btn-light mr-1"
                  v-if="wordcloud_created_at2"
                  >{{ $t("all.updated") }}:
                  {{ formatDateRefresh(wordcloud_created_at2) }}</span
                >
                <b-button
                  class="btn btn-sm"
                  variant="success"
                  @click="getWordCloudIG2"
                >
                  <span v-if="loadingword2"
                    ><b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner
                  ></span>
                  <span v-if="!loadingword2"><i class="bx bx-history"></i></span
                ></b-button>
              </div>
            </div>
            <div>
              <div class="text-center p-5">
                <div
                  class="col-sm-12 p-5 mb-5 pb-5"
                  v-if="loadingword2 && !wordCloud2[0]"
                >
                  <div class="text-center loading">
                    <b-spinner label="Loading..."></b-spinner>
                  </div>
                </div>
                <div
                  class="col-sm-12 pt-5 mb-5"
                  v-if="!wordCloud2[0] && !loadingword2"
                >
                  <div class="text-center text-secondary mt-5 pb-5">
                    {{ $t("all.dnf") }}
                  </div>
                </div>
                <div v-if="wordCloud2[0] && !loadingword2">
                  <vue-word-cloud
                    style="
                      height: 480px;
                      width: 100%;
                      font-family: arial, sans-serif;
                    "
                    :words="wordCloud2"
                     :color="
                      ([, weight]) =>
                        weight > 10
                          ? '#7f1d1d'
                          : weight > 5
                          ? '#a80a0a'
                          : '#d10404'
                    "
                    font-family="Poppins, sans-serif"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import VueWordCloud from "vuewordcloud";
import InstaService from "@/helpers/osintgram.service";
import PreferenceService from "@/helpers/preference.service.js";
import SosmedService from "@/helpers/socmed.service";
import moment from "moment";
import axios from "axios";
import { gmapApi } from "vue2-google-maps";
import { ref } from "vue";

export default {
  props: [
    "id1",
    "id2"
  ],
  page: {
    title: "instagram",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, VueWordCloud },
  data() {
    let sentimenOptions = {
      series: [],
    };
    let sentimenOptions2 = {
      series: [],
    };
    return {
      backUrl: "/instagram",
      theme: localStorage.getItem('theme'),
      id: this.id1,
      pref_userpost: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_userpost2: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_followers: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_followers2: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_following: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_following2: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_usertag: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_usertag2: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_similiar: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },

      pref_userinfo: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_userinfo2: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_avatar: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },

      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Instagram",
          href: "/Instagram",
        },
        {
          text: this.$t("instagram.instagram-view"),
          active: true,
        },
      ],

      elastic: "",
      rapid_get_post: [],
      avatar: process.env.VUE_APP_BASE_API_URL_OSINT + "stream-profil/?name=",
      avatar_instagram:
        "https://img.icons8.com/ios/240/000000/user-male-circle.png",
     
      sentimenOptions,
      label_sentiment: [],
      color_sentiment: [],
      cek_heatmap: false,
      loading: false,
      loadingtag: false,
      loadingfollowers: false,
      loadingSimiliar: false,
      loadingfollowing: false,
      loadingtimeline: false,
      loadingusertag: false,
      loadingupdatetimeline: false,
      loadingupdateusertag: false,
      loadingupdatewordcloud: false,
      loadingheatmap: false,
      loadingsentimen: false,
      loadingword: false,
      loadingupdateprofile: false,
      created_at_heatmap: "",
      sentiment_created_at: "",
      timeline_created_at: "",
      wordcloud_created_at: "",
      usertag_created_at: "",
      followers_created_at: "",
      following_created_at: "",
      similiar_created_at: "",
      word_cloud: [],
      wordCloud: [],
      sentiment: [],
      tableData: [],
      tableDataTags: [],
      tableDataFollowing: [],
      tableDataFollowers: [],
      tableDataSimiliar: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      currentPageTags: 1,
      perPageTags: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterTags: null,
      filterFollowers: null,
      filterFollowing: null,
      filterSimiliar: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      basicInfo: {
        id: "",
        name: "",
        username: "",
        category_name: "",
        bio: "",
        location: "",
        followers: "",
        following: "",
        media: "",
        join_date: "",
        join_time: "",
        avatar: "",
        avatar_hd: "",
        updated_at: "",
        is_private: "",
        is_verified: "",
      },
      fieldsTimeline: [
        { key: "id", thClass: "d-none", tdClass: "d-none" },
        { key: "code", thClass: "d-none", tdClass: "d-none" },
        {
          key: "taken_at",
          sortable: true,
          thStyle: { width: "15%" },
          label: this.$t("instagram.date-time"),
        },
        {
          key: "caption_text",
          sortable: true,
          label: this.$t("instagram.accessibility_caption"),
        },
        {
          key: "like_count",
          class: "text-center",
          sortable: true,
          thStyle: { width: "7%" },
          label: this.$t("instagram.likes"),
        },
        {
          key: "comment_count",
          class: "text-center",
          sortable: true,
          thStyle: { width: "7%" },
          label: this.$t("instagram.comments"),
        },
        {
          key: "actions",
          class: "text-center",
          thStyle: { width: "7%" },
          label: this.$t("instagram.action"),
        },
      ],
      fieldsUserTags: [
        { key: "id", thClass: "d-none", tdClass: "d-none" },
        { key: "link", thClass: "d-none", tdClass: "d-none" },
        {
          key: "taken_at",
          sortable: true,
          thStyle: { width: "15%" },
          label: this.$t("instagram.date-time"),
        },
        {
          key: "username",
          class: "text-center",
          sortable: true,
          thStyle: { width: "13%" },
          label: this.$t("instagram.account"),
        },
        {
          key: "caption_text",
          sortable: true,
          label: this.$t("instagram.accessibility_caption"),
        },
        {
          key: "like_count",
          class: "text-center",
          sortable: true,
          thStyle: { width: "7%" },
          label: this.$t("instagram.likes"),
        },
        {
          key: "comment_count",
          class: "text-center",
          sortable: true,
          thStyle: { width: "7%" },
          label: this.$t("instagram.comments"),
        },
        {
          key: "actions",
          class: "text-center",
          thStyle: { width: "7%" },
          label: this.$t("instagram.action"),
        },
      ],
      fieldsFollowing: [
        { key: "user_id", thClass: "d-none", tdClass: "d-none" },
        {
          key: "username",
          sortable: true,
          thStyle: { width: "45%" },
          label: this.$t("instagram.account"),
        },
        {
          key: "full_name",
          sortable: true,
          label: this.$t("instagram.full_name"),
        },
        // { key: "is_private", class: 'text-center', sortable: true, thStyle:{width: '20%'}, label: this.$t('instagram.is_private') },
        { key: "profile_pic_url", thClass: "d-none", tdClass: "d-none" },
      ],
      fieldsFollowers: [
        { key: "user_id", thClass: "d-none", tdClass: "d-none" },
        {
          key: "username",
          sortable: true,
          thStyle: { width: "45%" },
          label: this.$t("instagram.account"),
        },
        {
          key: "full_name",
          sortable: true,
          label: this.$t("instagram.full_name"),
        },
        // { key: "is_private", class: 'text-center', sortable: true, thStyle:{width: '20%'}, label: this.$t('instagram.is_private') },
        { key: "profile_pic_url", thClass: "d-none", tdClass: "d-none" },
      ],
      fieldsSimiliar: [
        { key: "user_id", thClass: "d-none", tdClass: "d-none" },
        {
          key: "username",
          sortable: true,
          thStyle: { width: "35%" },
          label: this.$t("instagram.account"),
        },
        {
          key: "full_name",
          sortable: true,
          label: this.$t("instagram.full_name"),
        },
        {
          key: "is_private",
          class: "text-center",
          sortable: true,
          thStyle: { width: "15%" },
          label: this.$t("instagram.is_private"),
        },
        {
          key: "is_verified",
          class: "text-center",
          sortable: true,
          thStyle: { width: "15%" },
          label: this.$t("Verified"),
        },
        { key: "profile_pic_url", thClass: "d-none", tdClass: "d-none" },
      ],
      heatmapSeries: [
        {
          name: "Sunday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Monday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Tuesday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Wednesday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Thursday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Friday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Saturday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
      ],
      location_coor: [],
      geocoder: null,
      center: { lat: parseFloat(-6.2), lng: parseFloat(106.816666) },
      zoom: 5,
      openedMarkerID: null,

      id_2: this.id2,
      basicInfo2: {
        id: "",
        name: "",
        username: "",
        category_name: "",
        bio: "",
        location: "",
        followers: "",
        following: "",
        media: "",
        join_date: "",
        join_time: "",
        avatar: "",
        avatar_hd: "",
        updated_at: "",
        is_private: "",
        is_verified: "",
      },
      sentimenOptions2,
      label_sentiment2: [],
      color_sentiment2: [],
      cek_heatmap2: false,
      loading2: false,
      loadingtag2: false,
      loadingfollowers2: false,
      loadingSimiliar2: false,
      loadingfollowing2: false,
      loadingtimeline2: false,
      loadingusertag2: false,
      loadingupdatetimeline2: false,
      loadingupdateusertag2: false,
      loadingupdatewordcloud2: false,
      loadingheatmap2: false,
      loadingsentimen2: false,
      loadingword2: false,
      loadingupdateprofile2: false,
      created_at_heatmap2: "",
      sentiment_created_at2: "",
      timeline_created_at2: "",
      wordcloud_created_at2: "",
      usertag_created_at2: "",
      followers_created_at2: "",
      following_created_at2: "",
      similiar_created_at2: "",
      word_cloud2: [],
      wordCloud2: [],
      sentiment2: [],
      tableData2: [],
      tableDataTags2: [],
      tableDataFollowing2: [],
      tableDataFollowers2: [],
      tableDataSimiliar2: [],
      totalRows2: 1,
      currentPage2: 1,
      perPage2: 10,
      currentPageTags2: 1,
      perPageTags2: 10,
      pageOptions2: [10, 25, 50, 100],
      filter2: null,
      filterTags2: null,
      filterFollowers2: null,
      filterFollowing2: null,
      filterSimiliar2: null,
      filterOn2: [],
      sortBy2: "age",
      sortDesc2: false,
    
      fieldsTimeline2: [
        { key: "id", thClass: "d-none", tdClass: "d-none" },
        { key: "code", thClass: "d-none", tdClass: "d-none" },
        {
          key: "taken_at",
          sortable: true,
          thStyle: { width: "15%" },
          label: this.$t("instagram.date-time"),
        },
        {
          key: "caption_text",
          sortable: true,
          label: this.$t("instagram.accessibility_caption"),
        },
        {
          key: "like_count",
          class: "text-center",
          sortable: true,
          thStyle: { width: "7%" },
          label: this.$t("instagram.likes"),
        },
        {
          key: "comment_count",
          class: "text-center",
          sortable: true,
          thStyle: { width: "7%" },
          label: this.$t("instagram.comments"),
        },
        {
          key: "actions",
          class: "text-center",
          thStyle: { width: "7%" },
          label: this.$t("instagram.action"),
        },
      ],
      fieldsUserTags2: [
        { key: "id", thClass: "d-none", tdClass: "d-none" },
        { key: "link", thClass: "d-none", tdClass: "d-none" },
        {
          key: "taken_at",
          sortable: true,
          thStyle: { width: "15%" },
          label: this.$t("instagram.date-time"),
        },
        {
          key: "username",
          class: "text-center",
          sortable: true,
          thStyle: { width: "13%" },
          label: this.$t("instagram.account"),
        },
        {
          key: "caption_text",
          sortable: true,
          label: this.$t("instagram.accessibility_caption"),
        },
        {
          key: "like_count",
          class: "text-center",
          sortable: true,
          thStyle: { width: "7%" },
          label: this.$t("instagram.likes"),
        },
        {
          key: "comment_count",
          class: "text-center",
          sortable: true,
          thStyle: { width: "7%" },
          label: this.$t("instagram.comments"),
        },
        {
          key: "actions",
          class: "text-center",
          thStyle: { width: "7%" },
          label: this.$t("instagram.action"),
        },
      ],
      fieldsFollowing2: [
        { key: "user_id", thClass: "d-none", tdClass: "d-none" },
        {
          key: "username",
          sortable: true,
          thStyle: { width: "45%" },
          label: this.$t("instagram.account"),
        },
        {
          key: "full_name",
          sortable: true,
          label: this.$t("instagram.full_name"),
        },
        // { key: "is_private", class: 'text-center', sortable: true, thStyle:{width: '20%'}, label: this.$t('instagram.is_private') },
        { key: "profile_pic_url", thClass: "d-none", tdClass: "d-none" },
      ],
      fieldsFollowers2: [
        { key: "user_id", thClass: "d-none", tdClass: "d-none" },
        {
          key: "username",
          sortable: true,
          thStyle: { width: "45%" },
          label: this.$t("instagram.account"),
        },
        {
          key: "full_name",
          sortable: true,
          label: this.$t("instagram.full_name"),
        },
        // { key: "is_private", class: 'text-center', sortable: true, thStyle:{width: '20%'}, label: this.$t('instagram.is_private') },
        { key: "profile_pic_url", thClass: "d-none", tdClass: "d-none" },
      ],
      fieldsSimiliar2: [
        { key: "user_id", thClass: "d-none", tdClass: "d-none" },
        {
          key: "username",
          sortable: true,
          thStyle: { width: "35%" },
          label: this.$t("instagram.account"),
        },
        {
          key: "full_name",
          sortable: true,
          label: this.$t("instagram.full_name"),
        },
        {
          key: "is_private",
          class: "text-center",
          sortable: true,
          thStyle: { width: "15%" },
          label: this.$t("instagram.is_private"),
        },
        {
          key: "is_verified",
          class: "text-center",
          sortable: true,
          thStyle: { width: "15%" },
          label: this.$t("Verified"),
        },
        { key: "profile_pic_url", thClass: "d-none", tdClass: "d-none" },
      ],
      heatmapSeries2: [
        {
          name: "Sunday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Monday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Tuesday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Wednesday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Thursday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Friday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Saturday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
      ],

      location_coor2: [],
      geocoder2: null,
      center2: { lat: parseFloat(-6.2), lng: parseFloat(106.816666) },
      zoom2: 5,
      openedMarkerID2: null,
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
    rowsTags() {
      return this.tableDataTags.length;
    },
    rowsFollowing() {
      return this.tableDataFollowing.length;
    },
    rowsFollowers() {
      return this.tableDataFollowers.length;
    },
    google: gmapApi,
  },
  methods: {
    getUserBasicInfo() {
      SosmedService.getDetailInstagram(this.id)
        .then((response) => {
          this.basicInfo.id = response.data.data.user_id;
          this.basicInfo.name = response.data.data.full_name;
          this.basicInfo.username = response.data.data.account;
          this.basicInfo.bio = response.data.data.bio;
          this.basicInfo.followers = response.data.data.followers;
          this.basicInfo.following = response.data.data.following;
          this.basicInfo.media = response.data.data.media;
          this.basicInfo.is_private = response.data.data.is_private;
          this.basicInfo.is_verified = response.data.data.is_verified;
          this.basicInfo.favorites = response.data.data.favorites;
          this.basicInfo.category_name = response.data.data.category_name;
          this.basicInfo.join_date = response.data.data.join_at;
          this.basicInfo.avatar = response.data.data.picture;
          this.basicInfo.avatar_hd = response.data.data.picture_hd;
          this.basicInfo.updated_at = response.data.data.updated_at;
        })
        .catch((err) => {
          console.log("basic err ->", err);
        });
    },

    getUserBasicInfo2() {
      SosmedService.getDetailInstagram(this.id_2)
        .then((response) => {
          this.basicInfo2.id = response.data.data.user_id;
          this.basicInfo2.name = response.data.data.full_name;
          this.basicInfo2.username = response.data.data.account;
          this.basicInfo2.bio = response.data.data.bio;
          this.basicInfo2.followers = response.data.data.followers;
          this.basicInfo2.following = response.data.data.following;
          this.basicInfo2.media = response.data.data.media;
          this.basicInfo2.is_private = response.data.data.is_private;
          this.basicInfo2.is_verified = response.data.data.is_verified;
          this.basicInfo2.favorites = response.data.data.favorites;
          this.basicInfo2.category_name = response.data.data.category_name;
          this.basicInfo2.join_date = response.data.data.join_at;
          this.basicInfo2.avatar = response.data.data.picture;
          this.basicInfo2.avatar_hd = response.data.data.picture_hd;
          this.basicInfo2.updated_at = response.data.data.updated_at;
        })
        .catch((err) => {
          console.log("basic err ->", err);
        });
    },

    // get preferences
    getPreferences() {
      PreferenceService.getAllElastic()
        .then((response) => {
          this.elastic = response.data.data[0].ip_address;
          this.getSentimentAnalys();
          this.getWordCloud();
          this.getTimeline();
          this.getHeatMap();
          this.getUserTag();
          this.getFollowers();
          this.getFollowing();
          this.getSimiliar();

          this.getSentimentAnalys2();
          this.getWordCloud2();
          this.getTimeline2();
          this.getHeatMap();
          this.getUserTag2();
          this.getFollowers2();
          this.getFollowing2();
          this.getSimiliar2();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getPreferencesAvatar() {
      let id = 62;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log('avatar', response.data.data);
          // this.pref_search = response.data.data;
          this.pref_avatar.api_host = response.data.data.api_host;
          this.pref_avatar.x_rapidapi_host = response.data.data.api_header_host;
          this.pref_avatar.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getPreferencesUserInfo() {
      let id = 13;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_userinfo = response.data.data;
          this.pref_userinfo.api_host = response.data.data.api_host;
          this.pref_userinfo.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_userinfo.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getPreferencesUserInfo2() {
      let id = 14;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_userinfo = response.data.data;
          this.pref_userinfo2.api_host = response.data.data.api_host;
          this.pref_userinfo2.x_rapidapi_host =
          response.data.data.api_header_host;
          this.pref_userinfo2.x_rapidapi_key =
          response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getPreferencesRapidUserPost() {
      let id = 50;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref = response.data.data;
          this.pref_userpost.api_host = response.data.data.api_host;
          this.pref_userpost.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_userpost.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPreferencesRapidUserPost2() {
      let id = 51;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref = response.data.data;
          this.pref_userpost2.api_host = response.data.data.api_host;
          this.pref_userpost2.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_userpost2.x_rapidapi_key =
            response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPreferencesRapidFollowers() {
      let id = 40;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_followers = response.data.data;
          this.api_host_followers = response.data.data.api_host;
          this.x_rapidapi_host_followers = response.data.data.api_header_host;
          this.x_rapidapi_key_followers = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPreferencesRapidFollowers2() {
      let id = 41;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_followers2 = response.data.data;
          this.pref_followers2.api_host = response.data.data.api_host;
          this.pref_followers2.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_followers2.x_rapidapi_key =
            response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPreferencesRapidFollowing() {
      let id = 30;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_following = response.data.data;
          this.pref_following.api_host = response.data.data.api_host;
          this.pref_following.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_following.x_rapidapi_key =
            response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPreferencesRapidFollowing2() {
      let id = 31;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_following = response.data.data;
          this.pref_following2.api_host = response.data.data.api_host;
          this.pref_following2.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_following2.x_rapidapi_key =
            response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPreferencesRapidUserTag() {
      let id = 20;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_usertag = response.data.data;
          this.pref_usertag.api_host = response.data.data.api_host;
          this.pref_usertag.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_usertag.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPreferencesRapidUserTag2() {
      let id = 21;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_usertag = response.data.data;
          this.pref_usertag2.api_host = response.data.data.api_host;
          this.pref_usertag2.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_usertag2.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPreferencesRapidUserSimiliar() {
      let id = 60;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_usertag = response.data.data;
          this.pref_similiar.api_host = response.data.data.api_host;
          this.pref_similiar.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_similiar.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    updateProfile() {
      this.loadingupdateprofile = true;
      var data = {
        nama: this.id,
      };
      this.getAvatarInstagram(this.id);
      InstaService.getUsername(data)
        .then((response) => {
          var data_akun = response.data.output;
          this.saveInstagram(data_akun);
        })
        .catch((err) => {
          console.log(err);
          //  console.log('update eror');
          this.addInstagramRapid(this.id);
          this.loadingupdateprofile = false;
        });
    },

    addInstagramRapid(username) {
      this.loading = true;
      this.searchResult = [];
      var user = username;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_userinfo.x_rapidapi_host,
        "x-rapidapi-key": this.pref_userinfo.x_rapidapi_key,
      };
      // console.log(headers);
      return axios
        .get(this.pref_userinfo.api_host + "?username=" + user, {
          headers: headers,
        })
        .then((response) => {
          var val = response.data;

          let data = {
            pk: val.id,
            username: val.username,
            full_name: val.full_name,
            biography: val.biography,
            following_count: val.edge_follow.count,
            follower_count: val.edge_followed_by.count,
            media_count: val.edge_owner_to_timeline_media.count,
            is_private: val.is_private,
            is_verified: val.is_verified,
            is_business: val.is_business_account,
            picture: val.profile_pic_url,
            picture_hd: val.profile_pic_url_hd,
            public_email: val.business_email,
            contact_phone_number: val.business_phone_number,
            bussiness_category_name: val.business_category_name,
            category_name: val.category_name,
          };
          this.saveInstagram(data);
        })
        .catch((err) => {
          this.addInstagramRapid2(user);
          console.log(err);
        });
    },

    addInstagramRapid2(username) {
      this.loading = true;
      this.searchResult = [];
      let user = username;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_userinfo2.x_rapidapi_host,
        "x-rapidapi-key": this.pref_userinfo2.x_rapidapi_key,
      };
      //  console.log(headers);
      return axios
        .get(this.pref_userinfo2.api_host + "?username=" + user, {
          headers: headers,
        })
        .then((response) => {
          var val = response.data;
          let data = {
            pk: val.id,
            username: val.username,
            full_name: val.full_name,
            biography: val.biography,
            following_count: val.edge_follow.count,
            follower_count: val.edge_followed_by.count,
            media_count: val.edge_owner_to_timeline_media.count,
            is_private: val.is_private,
            is_verified: val.is_verified,
            is_business: val.is_business_account,
            picture: val.profile_pic_url,
            picture_hd: val.profile_pic_url_hd,
            public_email: val.business_email,
            contact_phone_number: val.business_phone_number,
            bussiness_category_name: val.business_category_name,
            category_name: val.category_name,
          };
          this.saveInstagram(data);
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },

    saveInstagram(data) {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      var data_ig = {
        id_target: "",
        account: data.username,
        user_id: data.pk,
        full_name: data.full_name,
        bio: data.biography,
        following: data.following_count,
        followers: data.follower_count,
        media: data.media_count,
        is_private: data.is_private,
        is_verified: data.is_verified,
        is_business: data.is_business,
        picture: this.avatar_instagram,
        picture_hd: this.basicInfo.avatar_hd,
        public_email: data.public_email,
        contact_phone_number: data.contact_phone_number,
        business_category_name: data.business_category_name,
        category_name: data.category_name,
        updated_at: time,
      };
      SosmedService.createInstagram(data_ig)
        .then((response) => {
          this.loading = false;
          this.loadingupdateprofile = false;
          // console.log(response.data.data.updated_at);
          this.getUserBasicInfo();
        })
        .catch((err) => {
          console.log(err);
          this.loadingupdateprofile = false;
        });
    },

    //heatmap
    getHeatMap() {
      (this.loadingheatmap = true),
        InstaService.getHeatMapElastic(this.elastic, this.id)
          .then((response) => {
            this.created_at_heatmap = response.data._source.created_at;
            response.data._source.heatmap.forEach((element) => {
              this.cek_heatmap = true;
              this.heatmapSeries.forEach((series) => {
                if (element.day == series.name) {
                  series.data.forEach((d) => {
                    if (d.x == element.hour + ":00") {
                      d.y = element.count;
                    }
                  });
                }
              });
            });
            this.loadingheatmap = false;
          })
          .catch((err) => {
            if (err == "Error: Request failed with status code 404") {
              this.getHeatMapInsta();
            } else {
              console.log(err);
            }
          });
    },
    getHeatMapInsta() {
      this.loadingheatmap = true;
      const data = {
        user_id: this.basicInfo.id,
      };
      // console.log(data);
      InstaService.getHeatMap(data)
        .then((response) => {
          // console.log(response.data.output);
          this.heatmap = response.data.output;
          this.heatmapSeries = [
            {
              name: "Sunday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Monday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Tuesday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Wednesday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Thursday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Friday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Saturday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
          ];
          this.createUserHeatmap();
          response.data.output.forEach((element) => {
            this.cek_heatmap = true;
            this.heatmapSeries.forEach((series) => {
              if (element.day == series.name) {
                series.data.forEach((d) => {
                  if (d.x == element.hour + ":00") {
                    d.y = element.count;
                  }
                });
                // series.data.push({x: element.hour+':00', y:element.count})
              }
            });
          });
        })

        .catch((err) => {
          console.log("heatmap err ->", err);
          this.loadingheatmap = false;
        });
    },
    createUserHeatmap() {
      var heatmap = this.heatmap;
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id,
        heatmap: heatmap,
      };
      InstaService.createHeatMapElastic(this.elastic, this.id, data)
        .then((response) => {
          this.created_at_heatmap = time;
          this.loadingheatmap = false;
          // console.log('create heatmap',response);
        })
        .catch((err) => {
          console.log("create heatmap err ->", err);
          this.loadingheatmap = false;
        });
    },

    getHeatMap2() {
      (this.loadingheatmap2 = true),
        InstaService.getHeatMapElastic(this.elastic, this.id_2)
          .then((response) => {
            this.created_at_heatmap2 = response.data._source.created_at;
            response.data._source.heatmap.forEach((element) => {
              this.cek_heatmap2 = true;
              this.heatmapSeries2.forEach((series) => {
                if (element.day == series.name) {
                  series.data.forEach((d) => {
                    if (d.x == element.hour + ":00") {
                      d.y = element.count;
                    }
                  });
                }
              });
            });
            this.loadingheatmap2 = false;
          })
          .catch((err) => {
            if (err == "Error: Request failed with status code 404") {
              this.getHeatMapInsta2();
            } else {
              console.log(err);
            }
          });
    },
    getHeatMapInsta2() {
      this.loadingheatmap2 = true;
      const data = {
        user_id: this.basicInfo2.id,
      };
      // console.log(data);
      InstaService.getHeatMap(data)
        .then((response) => {
          // console.log(response.data.output);
          this.heatmap2 = response.data.output;
          this.heatmapSeries2 = [
            {
              name: "Sunday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Monday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Tuesday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Wednesday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Thursday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Friday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Saturday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
          ];
          this.createUserHeatmap2();
          response.data.output.forEach((element) => {
            this.cek_heatmap2 = true;
            this.heatmapSeries2.forEach((series) => {
              if (element.day == series.name) {
                series.data.forEach((d) => {
                  if (d.x == element.hour + ":00") {
                    d.y = element.count;
                  }
                });
                // series.data.push({x: element.hour+':00', y:element.count})
              }
            });
          });
        })

        .catch((err) => {
          console.log("heatmap err ->", err);
          this.loadingheatmap2 = false;
        });
    },
    createUserHeatmap2() {
      var heatmap = this.heatmap2;
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id,
        heatmap: heatmap,
      };
      InstaService.createHeatMapElastic(this.elastic, this.id_2, data)
        .then((response) => {
          this.created_at_heatmap2 = time;
          this.loadingheatmap2 = false;
          // console.log('create heatmap',response);
        })
        .catch((err) => {
          console.log("create heatmap err ->", err);
          this.loadingheatmap2 = false;
        });
    },

    getAvatarInstagram(username) {
      // if (this.searchKey != "") {
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_avatar.x_rapidapi_host,
        "x-rapidapi-key": this.pref_avatar.x_rapidapi_key,
      };
      // console.log(headers);
      return axios
        .get(
          this.pref_avatar.api_host +
            "?url=https://www.instagram.com/" +
            username +
            "/",
          { headers: headers }
        )
        .then((response) => {
          // console.log('avatar', response.data.data.image);
          this.avatar_instagram = response.data.data.image;
        })
        .catch((err) => {
          console.log(err);
          //   }
        });
      // }
    },

    // get last post
    getTimeline() {
      this.loadingtimeline = true;
      InstaService.getTimelineElastic(this.elastic, this.id)
        .then((response) => {
          this.tableData = response.data._source.timeline;
          this.timeline_created_at = response.data._source.created_at;
          this.loadingtimeline = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            if (!this.basicInfo.is_private) {
              this.getTimelineInstaRapid();
            } else {
              this.loadingtimeline = false;
            }
          } else {
            console.log(err);
            this.loadingtimeline = false;
          }
        });
    },
    getTimelineInstaRapid() {
      // console.log('rapid timeline on');
      this.loadingtimeline = true;
      this.loadingupdatetimeline = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_userpost.x_rapidapi_host,
        "x-rapidapi-key": this.pref_userpost.x_rapidapi_key,
      };

      return axios
        .get(
          this.pref_userpost.api_host +
            this.basicInfo.id +
            "/50/%7Bend_cursor%7D",
          { headers: headers }
        )
        .then((response) => {
          this.tableData = [];
          let rapid_data = response.data.data.edges;
          // console.log(response.data);
          rapid_data.forEach((val) => {
            if (val.node.edge_media_to_caption.edges[0]) {
              var caption = val.node.edge_media_to_caption.edges[0].node.text;
            }
            const data = {
              user_id: val.node.owner.id,
              id_timeline: val.node.id,
              code: val.node.shortcode,
              taken_at: this.formatDateTimes(val.node.taken_at_timestamp),
              media_type: 0,
              product_type: "",
              location: val.node.location,
              screen_name: val.node.owner.username,
              comment_count: val.node.edge_media_to_comment.count,
              like_count: val.node.edge_media_preview_like.count,
              caption_text: caption,
              view_count: 0,
              video_duration: 0,
              title: "",
            };
            this.tableData.push(data);
            this.loadingupdatetimeline = false;
          });

          this.createTimeline();
        })
        .catch((err) => {
          // console.log('timeline err ->',err);
          this.getTimelineInstaRapid2();
          // this.loadingtimeline = false;
          // this.loadingupdatetimeline = false;
        });
    },
    getTimelineInstaRapid2() {
      // console.log('rapid on');
      this.loadingtimeline = true;
      this.loadingupdatetimeline = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_userpost.x_rapidapi_host,
        "x-rapidapi-key": this.pref_userpost.x_rapidapi_key,
      };

      return axios
        .get(
          this.pref_userpost.api_host +
            this.basicInfo.id +
            "/50/%7Bend_cursor%7D",
          { headers: headers }
        )
        .then((response) => {
          this.tableData = [];
          let rapid_data = response.data.data.edges;
          // console.log(response.data);

          rapid_data.forEach((val) => {
            if (val.node.edge_media_to_caption.edges[0]) {
              var caption = val.node.edge_media_to_caption.edges[0].node.text;
            }
            const data = {
              user_id: val.node.owner.id,
              id_timeline: val.node.id,
              code: val.node.shortcode,
              taken_at: this.formatDateTimes(val.node.taken_at_timestamp),
              media_type: 0,
              product_type: "",
              location: val.node.location,
              screen_name: val.node.owner.username,
              comment_count: val.node.edge_media_to_comment.count,
              like_count: val.node.edge_media_preview_like.count,
              caption_text: caption,
              view_count: 0,
              video_duration: 0,
              title: "",
            };
            this.tableData.push(data);
            this.loadingupdatetimeline = false;
          });
          this.createTimeline();
        })
        .catch((err) => {
          // console.log('timeline 2 err ->',err);
          // this.loadingtimeline = false;
          // this.loadingupdatetimeline = false;
          this.getTimelineInsta();
        });
    },
    getTimelineInsta() {
      this.loadingtimeline = true;
      const data = {
        user_id: this.basicInfo.id,
      };
      this.loadingupdatetimeline = true;
      InstaService.getTimelineIG(data)
        .then((response) => {
          this.tableData = response.data.output;
          this.createTimeline();
          this.loadingupdatetimeline = false;
        })
        .catch((err) => {
          console.log("timeline err ->", err);
          // this.getTimelineInstaRapid();
          this.loadingtimeline = false;
          this.loadingupdatetimeline = false;
        });
    },
    createTimeline() {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id,
        timeline: this.tableData,
      };
      // console.log(data);
      InstaService.createTimelineElastic(this.elastic, this.id, data)
        .then((response) => {
          this.getHeatMapInsta();
          this.timeline_created_at = time;
          this.loadingtimeline = false;
        })
        .catch((err) => {
          console.log("timeline err ->", err);
          this.loadingtimeline = false;
        });
    },

    getTimeline2() {
      this.loadingtimeline2 = true;
      InstaService.getTimelineElastic(this.elastic, this.id_2)
        .then((response) => {
          this.tableData2 = response.data._source.timeline;
          this.timeline_created_at2 = response.data._source.created_at;
          this.loadingtimeline2 = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            if (!this.basicInfo2.is_private) {
              this.getTimelineInstaRapid2();
            } else {
              this.loadingtimeline2 = false;
            }
          } else {
            console.log(err);
            this.loadingtimeline2 = false;
          }
        });
    },
    getTimelineInstaRapid2() {
      // console.log('rapid timeline on');
      this.loadingtimeline2 = true;
      this.loadingupdatetimeline2 = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_userpost.x_rapidapi_host,
        "x-rapidapi-key": this.pref_userpost.x_rapidapi_key,
      };

      return axios
        .get(
          this.pref_userpost.api_host +
            this.basicInfo2.id +
            "/50/%7Bend_cursor%7D",
          { headers: headers }
        )
        .then((response) => {
          this.tableData = [];
          let rapid_data = response.data.data.edges;
          // console.log(response.data);
          rapid_data.forEach((val) => {
            if (val.node.edge_media_to_caption.edges[0]) {
              var caption = val.node.edge_media_to_caption.edges[0].node.text;
            }
            const data = {
              user_id: val.node.owner.id,
              id_timeline: val.node.id,
              code: val.node.shortcode,
              taken_at: this.formatDateTimes(val.node.taken_at_timestamp),
              media_type: 0,
              product_type: "",
              location: val.node.location,
              screen_name: val.node.owner.username,
              comment_count: val.node.edge_media_to_comment.count,
              like_count: val.node.edge_media_preview_like.count,
              caption_text: caption,
              view_count: 0,
              video_duration: 0,
              title: "",
            };
            this.tableData2.push(data);
            this.loadingupdatetimeline2 = false;
          });

          this.createTimeline2();
        })
        .catch((err) => {
          // console.log('timeline err ->',err);
          this.getTimelineInstaRapid22();
          // this.loadingtimeline = false;
          // this.loadingupdatetimeline = false;
        });
    },
    getTimelineInstaRapid22() {
      // console.log('rapid on');
      this.loadingtimeline2 = true;
      this.loadingupdatetimeline2 = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_userpost.x_rapidapi_host,
        "x-rapidapi-key": this.pref_userpost.x_rapidapi_key,
      };

      return axios
        .get(
          this.pref_userpost.api_host +
            this.basicInfo2.id +
            "/50/%7Bend_cursor%7D",
          { headers: headers }
        )
        .then((response) => {
          this.tableData = [];
          let rapid_data = response.data.data.edges;
          // console.log(response.data);

          rapid_data.forEach((val) => {
            if (val.node.edge_media_to_caption.edges[0]) {
              var caption = val.node.edge_media_to_caption.edges[0].node.text;
            }
            const data = {
              user_id: val.node.owner.id,
              id_timeline: val.node.id,
              code: val.node.shortcode,
              taken_at: this.formatDateTimes(val.node.taken_at_timestamp),
              media_type: 0,
              product_type: "",
              location: val.node.location,
              screen_name: val.node.owner.username,
              comment_count: val.node.edge_media_to_comment.count,
              like_count: val.node.edge_media_preview_like.count,
              caption_text: caption,
              view_count: 0,
              video_duration: 0,
              title: "",
            };
            this.tableData2.push(data);
            this.loadingupdatetimeline2 = false;
          });
          this.createTimeline2();
        })
        .catch((err) => {
          // console.log('timeline 2 err ->',err);
          // this.loadingtimeline = false;
          // this.loadingupdatetimeline = false;
          this.getTimelineInsta2();
        });
    },
    getTimelineInsta2() {
      this.loadingtimeline2 = true;
      const data = {
        user_id: this.basicInfo2.id,
      };
      this.loadingupdatetimeline2 = true;
      InstaService.getTimelineIG(data)
        .then((response) => {
          this.tableData2 = response.data.output;
          this.createTimeline2();
          this.loadingupdatetimeline2 = false;
        })
        .catch((err) => {
          console.log("timeline err ->", err);
          // this.getTimelineInstaRapid();
          this.loadingtimeline2 = false;
          this.loadingupdatetimeline2 = false;
        });
    },
    createTimeline2() {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id,
        timeline: this.tableData2,
      };
      // console.log(data);
      InstaService.createTimelineElastic(this.elastic, this.id_2, data)
        .then((response) => {
          this.getHeatMapInsta();
          this.timeline_created_at2 = time;
          this.loadingtimeline2 = false;
        })
        .catch((err) => {
          console.log("timeline err ->", err);
          this.loadingtimeline2 = false;
        });
    },

    // get last user tag
    getUserTag() {
      this.loadingtag = true;
      InstaService.getUserTagsElastic(this.elastic, this.id)
        .then((response) => {
          this.usertag_created_at = response.data._source.created_at;
          this.tableDataTags = response.data._source.usertag;
          this.loadingtag = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            if (!this.basicInfo.is_private) {
              this.getUserTagInstaRapid();
            } else {
              this.loadingtag = false;
            }
          } else {
            console.log(err);
            this.loadingtag = false;
          }
        });
    },
    getUserTagInstaRapid() {
      // console.log('rapid usertag on');
      this.loadingtag = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_usertag.x_rapidapi_host,
        "x-rapidapi-key": this.pref_usertag.x_rapidapi_key,
      };
      // console.log(headers, this.api_host_usertag);
      return axios
        .get(this.pref_usertag.api_host + "?id_user=" + this.basicInfo.id, {
          headers: headers,
        })
        .then((response) => {
          this.tableDataTags = [];
          let rapid_data =
            response.data.data.user.edge_user_to_photos_of_you.edges;
          // console.log(rapid_data);
          rapid_data.forEach((val) => {
            if (val.node.edge_media_to_caption.edges[0]) {
              var caption = val.node.edge_media_to_caption.edges[0].node.text;
            }
            const data = {
              id_post: val.node.id,
              pk: val.node.owner.id,
              code: val.node.shortcode,
              link: "https://www.instagram.com/p/" + val.node.shortcode + "/",
              taken_at: this.formatDateTimes(val.node.taken_at_timestamp),
              media_type: 1,
              product_type: "",
              thumbnail_url: val.node.thumbnail_src,
              location: null,
              screen_name: val.node.owner.username,
              comment_count: val.node.edge_media_to_comment.count,
              like_count: val.node.edge_liked_by.count,
              has_liked: null,
              caption_text: caption,
              usertags: [],
              video_url: null,
              view_count: 0,
              video_duration: 0,
              title: "",
              resources: [],
            };
            this.tableDataTags.push(data);
          });

          if (this.tableDataTags[0]) {
            this.createUserTag();
          }
          this.loadingupdateusertag = false;
        })
        .catch((err) => {
          console.log("usertag err ->", err);
          this.getUserTagInstaRapid2();
        });
    },
    getUserTagInstaRapid2() {
      // console.log('rapid usertag on');
      this.loadingtag = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_usertag2.x_rapidapi_host,
        "x-rapidapi-key": this.pref_usertag2.x_rapidapi_key,
      };
      // console.log(headers, this.api_host_usertag);
      return axios
        .get(this.pref_usertag2.api_host + "?id_user=" + this.basicInfo.id, {
          headers: headers,
        })
        .then((response) => {
          this.tableDataTags = [];
          let rapid_data =
            response.data.data.user.edge_user_to_photos_of_you.edges;
          // console.log(rapid_data);
          rapid_data.forEach((val) => {
            if (val.node.edge_media_to_caption.edges[0]) {
              var caption = val.node.edge_media_to_caption.edges[0].node.text;
            }
            const data = {
              id_post: val.node.id,
              pk: val.node.owner.id,
              code: val.node.shortcode,
              link: "https://www.instagram.com/p/" + val.node.shortcode + "/",
              taken_at: this.formatDateTimes(val.node.taken_at_timestamp),
              media_type: 1,
              product_type: "",
              thumbnail_url: val.node.thumbnail_src,
              location: null,
              screen_name: val.node.owner.username,
              comment_count: val.node.edge_media_to_comment.count,
              like_count: val.node.edge_liked_by.count,
              has_liked: null,
              caption_text: caption,
              usertags: [],
              video_url: null,
              view_count: 0,
              video_duration: 0,
              title: "",
              resources: [],
            };
            this.tableDataTags.push(data);
          });

          if (this.tableDataTags[0]) {
            this.createUserTag();
          }
          this.loadingupdateusertag = false;
        })
        .catch((err) => {
          console.log("usertag 2 err ->", err);
          this.getUserTagInsta();
        });
    },
    getUserTagInsta() {
      this.loadingtag = true;
      const data = {
        user_id: this.basicInfo.id,
      };
      this.loadingupdateusertag = true;
      InstaService.getUserTagsIG(data)
        .then((response) => {
          this.tableDataTags = response.data.output;
          this.createUserTag();
          this.loadingupdateusertag = false;
        })
        .catch((err) => {
          console.log("usertag err ->", err);
          this.loadingtag = false;
          this.loadingupdateusertag = false;
        });
    },
    createUserTag() {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id,
        usertag: this.tableDataTags,
      };

      InstaService.createUsertagElastic(this.elastic, this.id, data)
        .then((response) => {
          this.usertag_created_at = time;
          this.loadingtag = false;
        })
        .catch((err) => {
          console.log("usertag err ->", err);
          this.loadingtag = false;
        });
    },

    getUserTag2() {
      this.loadingtag2 = true;
      InstaService.getUserTagsElastic(this.elastic, this.id_2)
        .then((response) => {
          this.usertag_created_at2 = response.data._source.created_at;
          this.tableDataTags2 = response.data._source.usertag;
          this.loadingtag2 = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            if (!this.basicInfo2.is_private) {
              this.getUserTagInstaRapid2();
            } else {
              this.loadingtag2 = false;
            }
          } else {
            console.log(err);
            this.loadingtag2 = false;
          }
        });
    },
    getUserTagInstaRapid2() {
      // console.log('rapid usertag on');
      this.loadingtag2 = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_usertag.x_rapidapi_host,
        "x-rapidapi-key": this.pref_usertag.x_rapidapi_key,
      };
      // console.log(headers, this.api_host_usertag);
      return axios
        .get(this.pref_usertag.api_host + "?id_user=" + this.basicInfo2.id, {
          headers: headers,
        })
        .then((response) => {
          this.tableDataTags2 = [];
          let rapid_data =
            response.data.data.user.edge_user_to_photos_of_you.edges;
          // console.log(rapid_data);
          rapid_data.forEach((val) => {
            if (val.node.edge_media_to_caption.edges[0]) {
              var caption = val.node.edge_media_to_caption.edges[0].node.text;
            }
            const data = {
              id_post: val.node.id,
              pk: val.node.owner.id,
              code: val.node.shortcode,
              link: "https://www.instagram.com/p/" + val.node.shortcode + "/",
              taken_at: this.formatDateTimes(val.node.taken_at_timestamp),
              media_type: 1,
              product_type: "",
              thumbnail_url: val.node.thumbnail_src,
              location: null,
              screen_name: val.node.owner.username,
              comment_count: val.node.edge_media_to_comment.count,
              like_count: val.node.edge_liked_by.count,
              has_liked: null,
              caption_text: caption,
              usertags: [],
              video_url: null,
              view_count: 0,
              video_duration: 0,
              title: "",
              resources: [],
            };
            this.tableDataTags2.push(data);
          });

          if (this.tableDataTags2[0]) {
            this.createUserTag2();
          }
          this.loadingupdateusertag2 = false;
        })
        .catch((err) => {
          console.log("usertag err ->", err);
          this.getUserTagInstaRapid22();
        });
    },
    getUserTagInstaRapid22() {
      // console.log('rapid usertag on');
      this.loadingtag2 = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_usertag2.x_rapidapi_host,
        "x-rapidapi-key": this.pref_usertag2.x_rapidapi_key,
      };
      // console.log(headers, this.api_host_usertag);
      return axios
        .get(this.pref_usertag2.api_host + "?id_user=" + this.basicInfo.id, {
          headers: headers,
        })
        .then((response) => {
          this.tableDataTags2 = [];
          let rapid_data =
            response.data.data.user.edge_user_to_photos_of_you.edges;
          // console.log(rapid_data);
          rapid_data.forEach((val) => {
            if (val.node.edge_media_to_caption.edges[0]) {
              var caption = val.node.edge_media_to_caption.edges[0].node.text;
            }
            const data = {
              id_post: val.node.id,
              pk: val.node.owner.id,
              code: val.node.shortcode,
              link: "https://www.instagram.com/p/" + val.node.shortcode + "/",
              taken_at: this.formatDateTimes(val.node.taken_at_timestamp),
              media_type: 1,
              product_type: "",
              thumbnail_url: val.node.thumbnail_src,
              location: null,
              screen_name: val.node.owner.username,
              comment_count: val.node.edge_media_to_comment.count,
              like_count: val.node.edge_liked_by.count,
              has_liked: null,
              caption_text: caption,
              usertags: [],
              video_url: null,
              view_count: 0,
              video_duration: 0,
              title: "",
              resources: [],
            };
            this.tableDataTags2.push(data);
          });

          if (this.tableDataTags2[0]) {
            this.createUserTag2();
          }
          this.loadingupdateusertag2 = false;
        })
        .catch((err) => {
          console.log("usertag 2 err ->", err);
          this.getUserTagInsta2();
        });
    },
    getUserTagInsta2() {
      this.loadingtag2 = true;
      const data = {
        user_id: this.basicInfo2.id,
      };
      this.loadingupdateusertag2 = true;
      InstaService.getUserTagsIG(data)
        .then((response) => {
          this.tableDataTags2 = response.data.output;
          this.createUserTag2();
          this.loadingupdateusertag2 = false;
        })
        .catch((err) => {
          console.log("usertag err ->", err);
          this.loadingtag2 = false;
          this.loadingupdateusertag2 = false;
        });
    },
    createUserTag2() {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id,
        usertag: this.tableDataTags2,
      };

      InstaService.createUsertagElastic(this.elastic, this.id_2, data)
        .then((response) => {
          this.usertag_created_at2 = time;
          this.loadingtag2 = false;
        })
        .catch((err) => {
          console.log("usertag err ->", err);
          this.loadingtag2 = false;
        });
    },

    // word cloud
    getWordCloud() {
      this.loadingword = true;
      InstaService.getWordcloudElastic(this.elastic, this.id)
        .then((response) => {
          this.wordcloud_created_at = response.data._source.created_at;
          response.data._source.wordcloud.forEach((element, i) => {
            this.wordCloud.push([element.word, element.count]);
          });
          this.loadingword = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            if (!this.basicInfo.is_private) {
              this.getWordCloudIG();
            } else {
              this.loadingword = false;
            }
          } else {
            console.log(err);
            this.loadingword = false;
          }
        });
    },
    getWordCloudIG() {
      this.loadingword = true;
      const data = {
        user_id: this.basicInfo.id,
      };

      if (!this.basicInfo.is_private) {
        this.wordCloud = [];
        InstaService.getWordCloud(data)
          .then((response) => {
            this.word_cloud = response.data.output;
            // console.log(response.data.output);
            var word_cloud = response.data.output;
            if (word_cloud) {
              this.createUserWordcloud();
              response.data.output.forEach((element, i) => {
                this.wordCloud.push([element.word, element.count]);
              });
            }
          })
          .catch((err) => {
            console.log("word cloud err ->", err);
            this.loadingword = false;
          });
      } else {
        this.loadingword = false;
        console.log("false");
      }
    },
    createUserWordcloud() {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      //   console.log(this.word_cloud);
      const data = {
        created_at: time,
        username: this.id,
        wordcloud: this.word_cloud,
      };
      InstaService.createWordCloudElastic(this.elastic, this.id, data)
        .then((response) => {
          this.wordcloud_created_at = time;
          this.loadingword = false;
        })
        .catch((err) => {
          console.log("wordcloud err ->", err);
          this.loadingword = false;
        });
    },
    getSentimentAnalys() {
      this.loadingsentimen = true;
      InstaService.getSentimentElastic(this.elastic, this.id)
        .then((response) => {
          this.sentiment_created_at = response.data._source.created_at;
          response.data._source.sentiment.forEach((event) => {
            this.label_sentiment.push(event.sentiment);
            this.color_sentiment.push(event.color);
            this.sentimenOptions.series.push(event.count);
          });
          this.loadingsentimen = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            if (!this.basicInfo.is_private) {
              this.getSentimentAnalysIG();
            } else {
              this.loadingsentimen = false;
            }
          } else {
            console.log(err);
            this.loading = true;

            this.loadingsentimen = false;
          }
        });
    },
    getSentimentAnalysIG() {
      this.loadingsentimen = true;
      const data = {
        user_id: this.basicInfo.id,
      };
      this.label_sentiment = [];
      this.color_sentiment = [];
      InstaService.SentimentAnalys(data)
        .then((response) => {
          this.sentimenOptions.series = [];
          this.sentiment = response.data.output;
          this.createUserSentiment();
          var today = new Date();
          var time = today.toLocaleString("en-US", {
            timeZone: "Asia/Jakarta",
          });
          this.sentiment_created_at = time;
          response.data.output.forEach((event) => {
            this.label_sentiment.push(event.sentiment);
            this.color_sentiment.push(event.color);
            this.sentimenOptions.series.push(event.count);
            // console.log(event.count);
          });
        })
        .catch((err) => {
          console.log("sentiment err ->", err);
          this.loadingsentimen = false;
        });
    },
    createUserSentiment() {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id,
        sentiment: this.sentiment,
      };
      InstaService.createSentimentElastic(this.elastic, this.id, data)
        .then((response) => {
          this.loadingsentimen = false;
        })
        .catch((err) => {
          console.log("sentiment err ->", err);
          this.loadingsentimen = false;
        });
    },

    getWordCloud2() {
      this.loadingword2 = true;
      InstaService.getWordcloudElastic(this.elastic, this.id_2)
        .then((response) => {
          this.wordcloud_created_at2 = response.data._source.created_at;
          response.data._source.wordcloud.forEach((element, i) => {
            this.wordCloud2.push([element.word, element.count]);
          });
          this.loadingword2 = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            if (!this.basicInfo2.is_private) {
              this.getWordCloudIG();
            } else {
              this.loadingword2 = false;
            }
          } else {
            console.log(err);
            this.loadingword2 = false;
          }
        });
    },
    getWordCloudIG2() {
      this.loadingword2 = true;
      const data = {
        user_id: this.basicInfo.id,
      };

      if (!this.basicInfo2.is_private) {
        this.wordCloud2 = [];
        InstaService.getWordCloud(data)
          .then((response) => {
            this.word_cloud2 = response.data.output;
            // console.log(response.data.output);
            var word_cloud = response.data.output;
            if (word_cloud) {
              this.createUserWordcloud2();
              response.data.output.forEach((element, i) => {
                this.wordCloud2.push([element.word, element.count]);
              });
            }
          })
          .catch((err) => {
            console.log("word cloud err ->", err);
            this.loadingword2 = false;
          });
      } else {
        this.loadingword2 = false;
        console.log("false");
      }
    },
    createUserWordcloud2() {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      //   console.log(this.word_cloud);
      const data = {
        created_at: time,
        username: this.id,
        wordcloud: this.word_cloud,
      };
      InstaService.createWordCloudElastic(this.elastic, this.id_2, data)
        .then((response) => {
          this.wordcloud_created_at2 = time;
          this.loadingword2 = false;
        })
        .catch((err) => {
          console.log("wordcloud err ->", err);
          this.loadingword2 = false;
        });
    },

    getSentimentAnalys2() {
      this.loadingsentimen2 = true;
      InstaService.getSentimentElastic(this.elastic, this.id_2)
        .then((response) => {
          this.sentiment_created_at2 = response.data._source.created_at;
          response.data._source.sentiment.forEach((event) => {
            this.label_sentiment2.push(event.sentiment);
            this.color_sentiment2.push(event.color);
            this.sentimenOptions2.series.push(event.count);
          });
          this.loadingsentimen2 = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            if (!this.basicInfo2.is_private) {
              this.getSentimentAnalysIG2();
            } else {
              this.loadingsentimen2 = false;
            }
          } else {
            console.log(err);
            this.loading2 = true;
            this.loadingsentimen2 = false;
          }
        });
    },
    getSentimentAnalysIG2() {
      this.loadingsentimen2 = true;
      const data = {
        user_id: this.basicInfo2.id,
      };
      this.label_sentiment2 = [];
      this.color_sentiment2 = [];
      InstaService.SentimentAnalys(data)
        .then((response) => {
          this.sentimenOptions2.series = [];
          this.sentiment2 = response.data.output;
          this.createUserSentiment2();
          var today = new Date();
          var time = today.toLocaleString("en-US", {
            timeZone: "Asia/Jakarta",
          });
          this.sentiment_created_at = time;
          response.data.output.forEach((event) => {
            this.label_sentiment2.push(event.sentiment);
            this.color_sentiment2.push(event.color);
            this.sentimenOptions2.series.push(event.count);
            // console.log(event.count);
          });
        })
        .catch((err) => {
          console.log("sentiment err ->", err);
          this.loadingsentimen2 = false;
        });
    },
    createUserSentiment2() {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id_2,
        sentiment: this.sentiment2,
      };
      InstaService.createSentimentElastic(this.elastic, this.id_2, data)
        .then((response) => {
          this.loadingsentimen2 = false;
        })
        .catch((err) => {
          console.log("sentiment err ->", err);
          this.loadingsentimen2 = false;
        });
    },

    // get last following
    getFollowing() {
      (this.loadingfollowing = true),
        InstaService.getFollowingElastic(this.elastic, this.id)
          .then((response) => {
            this.following_created_at = response.data._source.created_at;
            this.tableDataFollowing = response.data._source.following;
            this.loadingfollowing = false;
          })
          .catch((err) => {
            if (err == "Error: Request failed with status code 404") {
              if (!this.basicInfo.is_private) {
                this.getFollowingIGRapid();
              } else {
                this.loadingfollowing = false;
              }
            } else {
              console.log(err);
              this.loadingfollowing = false;
            }
          });
    },
    getFollowingIGRapid() {
      // console.log('rapid following on');
      this.loadingfollowing = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_following.x_rapidapi_host,
        "x-rapidapi-key": this.pref_following.x_rapidapi_key,
      };
      return axios
        .get(
          this.pref_following.api_host +
            "?user_id=" +
            this.basicInfo.id +
            "&batch_size=10",
          { headers: headers }
        )
        .then((response) => {
          this.tableDataFollowing = [];
          let rapid_data = response.data.data.user.edge_follow.edges;
          // console.log(rapid_data);
          rapid_data.forEach((val) => {
            const data = {
              user_id: val.node.id,
              username: val.node.username,
              full_name: val.node.full_name,
              is_private: val.node.is_private,
              profile_pic_url: val.node.profile_pic_url,
            };
            this.tableDataFollowing.push(data);
            this.loadingfollowing = false;
          });

          if (this.tableDataFollowing[0]) {
            this.createFollowing();
            this.loadingfollowing = false;
          } else {
            this.loadingfollowing = false;
          }
        })
        .catch((err) => {
          console.log("following err ->", err);
          this.getFollowingIGRapid2();
        });
    },
    getFollowingIGRapid2() {
      // console.log('rapid following on');
      this.loadingfollowing = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_following2.x_rapidapi_host,
        "x-rapidapi-key": this.pref_following2.x_rapidapi_key,
      };

      return axios
        .get(
          this.pref_following2.api_host +
            "?user_id=" +
            this.basicInfo.id +
            "&batch_size=10",
          { headers: headers }
        )
        .then((response) => {
          this.tableDataFollowing = [];
          let rapid_data = response.data.data.user.edge_follow.edges;
          // console.log(rapid_data);
          rapid_data.forEach((val) => {
            const data = {
              user_id: val.node.id,
              username: val.node.username,
              full_name: val.node.full_name,
              is_private: val.node.is_private,
              profile_pic_url: val.node.profile_pic_url,
            };
            this.tableDataFollowing.push(data);
            this.loadingfollowing = false;
          });

          if (this.tableDataFollowing[0]) {
            this.createFollowing();
            this.loadingfollowing = false;
          } else {
            this.loadingfollowing = false;
          }
        })
        .catch((err) => {
          console.log("following 2 err ->", err);
          this.getFollowingIG();
        });
    },
    getFollowingIG() {
      const data = {
        user_id: this.basicInfo.id,
      };
      (this.loadingfollowing = true),
        InstaService.Following(data)
          .then((response) => {
            this.tableDataFollowing = response.data.output;
            if (this.tableDataFollowing[0]) {
              this.createFollowing();
            } else {
              this.loadingfollowing = false;
            }
          })
          .catch((err) => {
            console.log("following err ->", err);
            this.loadingfollowing = false;
          });
    },
    createFollowing() {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      this.following_created_at = time;
      const data = {
        created_at: time,
        username: this.id,
        following: this.tableDataFollowing,
      };
      InstaService.createFollowingElastic(this.elastic, this.id, data)
        .then((response) => {
          this.loadingfollowing = false;
        })
        .catch((err) => {
          console.log("following err ->", err);
          this.loadingfollowing = false;
        });
    },

    getFollowing2() {
      (this.loadingfollowing2 = true),
        InstaService.getFollowingElastic(this.elastic, this.id_2)
          .then((response) => {
            this.following_created_at2 = response.data._source.created_at;
            this.tableDataFollowing2 = response.data._source.following;
            this.loadingfollowing2 = false;
          })
          .catch((err) => {
            if (err == "Error: Request failed with status code 404") {
              if (!this.basicInfo2.is_private) {
                this.getFollowingIGRapid2();
              } else {
                this.loadingfollowing2 = false;
              }
            } else {
              console.log(err);
              this.loadingfollowing2 = false;
            }
          });
    },
    getFollowingIGRapid2() {
      // console.log('rapid following on');
      this.loadingfollowing2 = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_following.x_rapidapi_host,
        "x-rapidapi-key": this.pref_following.x_rapidapi_key,
      };
      return axios
        .get(
          this.pref_following.api_host +
            "?user_id=" +
            this.basicInfo2.id +
            "&batch_size=10",
          { headers: headers }
        )
        .then((response) => {
          this.tableDataFollowing2 = [];
          let rapid_data = response.data.data.user.edge_follow.edges;
          // console.log(rapid_data);
          rapid_data.forEach((val) => {
            const data = {
              user_id: val.node.id,
              username: val.node.username,
              full_name: val.node.full_name,
              is_private: val.node.is_private,
              profile_pic_url: val.node.profile_pic_url,
            };
            this.tableDataFollowing2.push(data);
            this.loadingfollowing2 = false;
          });

          if (this.tableDataFollowing2[0]) {
            this.createFollowing2();
            this.loadingfollowing2 = false;
          } else {
            this.loadingfollowing2 = false;
          }
        })
        .catch((err) => {
          console.log("following err ->", err);
          this.getFollowingIGRapid22();
        });
    },
    getFollowingIGRapid22() {
      // console.log('rapid following on');
      this.loadingfollowing2 = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_following2.x_rapidapi_host,
        "x-rapidapi-key": this.pref_following2.x_rapidapi_key,
      };

      return axios
        .get(
          this.pref_following2.api_host +
            "?user_id=" +
            this.basicInfo2.id +
            "&batch_size=10",
          { headers: headers }
        )
        .then((response) => {
          this.tableDataFollowing2 = [];
          let rapid_data = response.data.data.user.edge_follow.edges;
          // console.log(rapid_data);
          rapid_data.forEach((val) => {
            const data = {
              user_id: val.node.id,
              username: val.node.username,
              full_name: val.node.full_name,
              is_private: val.node.is_private,
              profile_pic_url: val.node.profile_pic_url,
            };
            this.tableDataFollowing2.push(data);
            this.loadingfollowing2 = false;
          });

          if (this.tableDataFollowing2[0]) {
            this.createFollowing2();
            this.loadingfollowing2 = false;
          } else {
            this.loadingfollowing2 = false;
          }
        })
        .catch((err) => {
          console.log("following 2 err ->", err);
          this.getFollowingIG2();
        });
    },
    getFollowingIG2() {
      const data = {
        user_id: this.basicInfo2.id,
      };
      (this.loadingfollowing2 = true),
        InstaService.Following(data)
          .then((response) => {
            this.tableDataFollowing2 = response.data.output;
            if (this.tableDataFollowing2[0]) {
              this.createFollowing2();
            } else {
              this.loadingfollowing2 = false;
            }
          })
          .catch((err) => {
            console.log("following err ->", err);
            this.loadingfollowing2 = false;
          });
    },
    createFollowing2() {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      this.following_created_at2 = time;
      const data = {
        created_at: time,
        username: this.id_2,
        following: this.tableDataFollowing2,
      };
      InstaService.createFollowingElastic(this.elastic, this.id_2, data)
        .then((response) => {
          this.loadingfollowing2 = false;
        })
        .catch((err) => {
          console.log("following err ->", err);
          this.loadingfollowing2 = false;
        });
    },

    // get last followers
    getFollowers() {
      this.loadingfollowers = true;
      InstaService.getFollowersElastic(this.elastic, this.id)
        .then((response) => {
          this.followers_created_at = response.data._source.created_at;
          this.tableDataFollowers = response.data._source.followers;
          this.loadingfollowers = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            if (!this.basicInfo.is_private) {
              this.getFollowersIGRapid();
            } else {
              this.loadingfollowers = false;
            }
          } else {
            console.log(err);
            this.loadingfollowers = false;
          }
        });
    },
    getFollowersIGRapid() {
      // console.log('rapid followers on');
      this.loadingfollowers = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_followers.x_rapidapi_host,
        "x-rapidapi-key": this.pref_followers.x_rapidapi_key,
      };

      return axios
        .get(
          this.pref_followers.api_host +
            "?user_id=" +
            this.basicInfo.id +
            "&batch_size=10",
          { headers: headers }
        )
        .then((response) => {
          this.tableDataFollowers = [];
          let rapid_data = response.data.data.user.edge_followed_by.edges;
          // console.log(rapid_data);
          rapid_data.forEach((val) => {
            const data = {
              user_id: val.node.id,
              username: val.node.username,
              full_name: val.node.full_name,
              is_private: val.node.is_private,
              profile_pic_url: val.node.profile_pic_url,
            };
            this.tableDataFollowers.push(data);
            this.loadingfollowers = false;
          });

          if (this.tableDataFollowers[0]) {
            this.createFollowers();
            this.loadingfollowers = false;
          } else {
            this.loadingfollowers = false;
          }
        })
        .catch((err) => {
          console.log("get followers err ->", err);
          this.getFollowersIGRapid2();
        });
    },
    getFollowersIGRapid2() {
      // console.log('rapid followers on');
      this.loadingfollowers = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_followers2.x_rapidapi_host,
        "x-rapidapi-key": this.pref_followers2.x_rapidapi_key,
      };

      return axios
        .get(
          this.pref_followers2.api_host +
            "?user_id=" +
            this.basicInfo.id +
            "&batch_size=10",
          { headers: headers }
        )
        .then((response) => {
          this.tableDataFollowers = [];
          let rapid_data = response.data.data.user.edge_followed_by.edges;
          // console.log(rapid_data);
          rapid_data.forEach((val) => {
            const data = {
              user_id: val.node.id,
              username: val.node.username,
              full_name: val.node.full_name,
              is_private: val.node.is_private,
              profile_pic_url: val.node.profile_pic_url,
            };
            this.tableDataFollowers.push(data);
            this.loadingfollowers = false;
          });

          if (this.tableDataFollowers[0]) {
            this.createFollowers();
            this.loadingfollowers = false;
          } else {
            this.loadingfollowers = false;
          }
        })
        .catch((err) => {
          console.log("followers err ->", err);
          this.getFollowersIG();
        });
    },
    getFollowersIG() {
      this.loadingfollowers = true;
      const data = {
        user_id: this.basicInfo.id,
      };
      InstaService.Followers(data)
        .then((response) => {
          this.tableDataFollowers = response.data.output;
          if (this.tableDataFollowers[0]) {
            this.createFollowers();
          } else {
            this.loadingfollowers = false;
          }
        })
        .catch((err) => {
          console.log("followers err ->", err);
          this.loadingfollowers = false;
        });
    },
    createFollowers() {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      this.followers_created_at = time;
      const data = {
        created_at: time,
        username: this.id,
        followers: this.tableDataFollowers,
      };
      InstaService.createFollowersElastic(this.elastic, this.id, data)
        .then((response) => {
          this.loadingfollowers = false;
        })
        .catch((err) => {
          console.log("followers err ->", err);
          this.loadingfollowers = false;
        });
    },

    getFollowers2() {
      this.loadingfollowers2 = true;
      InstaService.getFollowersElastic(this.elastic, this.id_2)
        .then((response) => {
          this.followers_created_at2 = response.data._source.created_at;
          this.tableDataFollowers2 = response.data._source.followers;
          this.loadingfollowers2 = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            if (!this.basicInfo2.is_private) {
              this.getFollowersIGRapid2();
            } else {
              this.loadingfollowers2 = false;
            }
          } else {
            console.log(err);
            this.loadingfollowers2 = false;
          }
        });
    },
    getFollowersIGRapid2() {
      // console.log('rapid followers on');
      this.loadingfollowers2 = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_followers.x_rapidapi_host,
        "x-rapidapi-key": this.pref_followers.x_rapidapi_key,
      };

      return axios
        .get(
          this.pref_followers.api_host +
            "?user_id=" +
            this.basicInfo2.id +
            "&batch_size=10",
          { headers: headers }
        )
        .then((response) => {
          this.tableDataFollowers2 = [];
          let rapid_data = response.data.data.user.edge_followed_by.edges;
          // console.log(rapid_data);
          rapid_data.forEach((val) => {
            const data = {
              user_id: val.node.id,
              username: val.node.username,
              full_name: val.node.full_name,
              is_private: val.node.is_private,
              profile_pic_url: val.node.profile_pic_url,
            };
            this.tableDataFollowers2.push(data);
            this.loadingfollowers2 = false;
          });

          if (this.tableDataFollowers2[0]) {
            this.createFollowers22();
            this.loadingfollowers2 = false;
          } else {
            this.loadingfollowers2 = false;
          }
        })
        .catch((err) => {
          console.log("get followers err ->", err);
          this.getFollowersIGRapid2();
        });
    },
    getFollowersIGRapid22() {
      // console.log('rapid followers on');
      this.loadingfollowers2 = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_followers2.x_rapidapi_host,
        "x-rapidapi-key": this.pref_followers2.x_rapidapi_key,
      };

      return axios
        .get(
          this.pref_followers2.api_host +
            "?user_id=" +
            this.basicInfo2.id +
            "&batch_size=10",
          { headers: headers }
        )
        .then((response) => {
          this.tableDataFollowers2 = [];
          let rapid_data = response.data.data.user.edge_followed_by.edges;
          // console.log(rapid_data);
          rapid_data.forEach((val) => {
            const data = {
              user_id: val.node.id,
              username: val.node.username,
              full_name: val.node.full_name,
              is_private: val.node.is_private,
              profile_pic_url: val.node.profile_pic_url,
            };
            this.tableDataFollowers2.push(data);
            this.loadingfollowers2 = false;
          });

          if (this.tableDataFollowers2[0]) {
            this.createFollowers2();
            this.loadingfollowers2 = false;
          } else {
            this.loadingfollowers2 = false;
          }
        })
        .catch((err) => {
          console.log("followers err ->", err);
          this.getFollowersIG2();
        });
    },
    getFollowersIG2() {
      this.loadingfollowers2 = true;
      const data = {
        user_id: this.basicInfo2.id,
      };
      InstaService.Followers(data)
        .then((response) => {
          this.tableDataFollowers2 = response.data.output;
          if (this.tableDataFollowers2[0]) {
            this.createFollowers2();
          } else {
            this.loadingfollowers2 = false;
          }
        })
        .catch((err) => {
          console.log("followers err ->", err);
          this.loadingfollowers2 = false;
        });
    },
    createFollowers2() {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      this.followers_created_at2 = time;
      const data = {
        created_at: time,
        username: this.id,
        followers: this.tableDataFollowers,
      };
      InstaService.createFollowersElastic(this.elastic, this.id_2, data)
        .then((response) => {
          this.loadingfollowers2 = false;
        })
        .catch((err) => {
          console.log("followers err ->", err);
          this.loadingfollowers2 = false;
        });
    },

    //similiar account
    getSimiliar() {
      this.loadingsimiliar = true;
      InstaService.getSimiliarElastic(this.elastic, this.id)
        .then((response) => {
          this.similiar_created_at = response.data._source.created_at;
          this.tableDataSimiliar = response.data._source.similiar;
          this.loadingsimiliar = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            if (!this.basicInfo.is_private) {
              this.getSimiliarAccount();
            } else {
              this.loadingsimiliar = false;
            }
          } else {
            console.log(err);
            this.loadingsimiliar = false;
          }
        });
    },
    getSimiliarAccount() {
      // console.log('rapid followers on');
      this.loadingSimiliar = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_similiar.x_rapidapi_host,
        "x-rapidapi-key": this.pref_similiar.x_rapidapi_key,
      };
      // console.log(headers);
      return axios
        .get(this.pref_similiar.api_host + "?id_user=" + this.basicInfo.id, {
          headers: headers,
        })
        .then((response) => {
          this.tableDataSimiliar = [];
          let rapid_data = response.data.data.user.edge_chaining.edges;
          // console.log(rapid_data);
          rapid_data.forEach((val) => {
            const data = {
              user_id: val.node.id,
              username: val.node.username,
              full_name: val.node.full_name,
              is_private: val.node.is_private,
              is_verified: val.node.is_verified,
              profile_pic_url: val.node.profile_pic_url,
            };
            this.tableDataSimiliar.push(data);
            this.loadingSimiliar = false;
          });

          if (this.tableDataSimiliar[0]) {
            this.createSimiliar();
            this.loadingSimiliar = false;
          } else {
            this.loadingSimiliar = false;
          }
        })
        .catch((err) => {
          console.log("get similiar err ->", err);
          //     this.loadingSimiliar = false;
        });
    },
    createSimiliar() {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      this.similiar_created_at = time;
      const data = {
        created_at: time,
        username: this.id,
        similiar: this.tableDataSimiliar,
      };
      InstaService.createSimiliarElastic(this.elastic, this.id, data)
        .then((response) => {
          this.loadingSimiliar = false;
        })
        .catch((err) => {
          console.log("similiar err ->", err);
          this.loadingSimiliar = false;
        });
    },

    getSimiliar2() {
      this.loadingsimiliar2 = true;
      InstaService.getSimiliarElastic(this.elastic, this.id_2)
        .then((response) => {
          this.similiar_created_at2 = response.data._source.created_at;
          this.tableDataSimiliar2 = response.data._source.similiar;
          this.loadingsimiliar2 = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            if (!this.basicInfo.is_private) {
              this.getSimiliarAccount2();
            } else {
              this.loadingsimiliar2 = false;
            }
          } else {
            console.log(err);
            this.loadingsimiliar2 = false;
          }
        });
    },
    getSimiliarAccount2() {
      // console.log('rapid followers on');
      this.loadingSimiliar2 = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_similiar.x_rapidapi_host,
        "x-rapidapi-key": this.pref_similiar.x_rapidapi_key,
      };
      // console.log(headers);
      return axios
        .get(this.pref_similiar.api_host + "?id_user=" + this.basicInfo.id, {
          headers: headers,
        })
        .then((response) => {
          this.tableDataSimiliar2 = [];
          let rapid_data = response.data.data.user.edge_chaining.edges;
          // console.log(rapid_data);
          rapid_data.forEach((val) => {
            const data = {
              user_id: val.node.id,
              username: val.node.username,
              full_name: val.node.full_name,
              is_private: val.node.is_private,
              is_verified: val.node.is_verified,
              profile_pic_url: val.node.profile_pic_url,
            };
            this.tableDataSimiliar.push(data);
            this.loadingSimiliar2 = false;
          });

          if (this.tableDataSimiliar[0]) {
            this.createSimiliar();
            this.loadingSimiliar2 = false;
          } else {
            this.loadingSimiliar2 = false;
          }
        })
        .catch((err) => {
          console.log("get similiar err ->", err);
          //     this.loadingSimiliar = false;
        });
    },
    createSimiliar2() {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      this.similiar_created_at2 = time;
      const data = {
        created_at: time,
        username: this.id,
        similiar: this.tableDataSimiliar2,
      };
      InstaService.createSimiliarElastic(this.elastic, this.id, data)
        .then((response) => {
          this.loadingSimiliar2 = false;
        })
        .catch((err) => {
          console.log("similiar err ->", err);
          this.loadingSimiliar2 = false;
        });
    },

    //map
    geocodedAddress() {
      this.$gmapApiPromiseLazy().then(() => {
        if (this.google) {
          this.geocoder = new this.google.maps.Geocoder();
        }
      });
      this.location_coor = [];
      this.tableData.forEach((element) => {
        if (Object.keys(element.place).length !== 0) {
          this.geocoder.geocode(
            { address: element.place.full_name },
            (results, status) => {
              this.location_coor.push({
                lat: results[0].geometry.location.lat(),
                long: results[0].geometry.location.lng(),
                content: element,
              });
            }
          );
        }
      });
    },

    geocodedAddress2() {
      this.$gmapApiPromiseLazy().then(() => {
        if (this.google) {
          this.geocoder2 = new this.google.maps.Geocoder();
        }
      });
      this.location_coo2r = [];
      this.tableData2.forEach((element) => {
        if (Object.keys(element.place).length !== 0) {
          this.geocoder2.geocode(
            { address: element.place.full_name },
            (results, status) => {
              this.location_coor2.push({
                lat: results[0].geometry.location.lat(),
                long: results[0].geometry.location.lng(),
                content: element,
              });
            }
          );
        }
      });
    },
    openMarker(id) {
      this.openedMarkerID = id;
    },
    openMarker2(id) {
      this.openedMarkerID2 = id;
    },

    formatDateTimes(value) {
      var unixTime = value;
      var momentDate = moment.unix(unixTime),
        momentDay = momentDate.format("DD"),
        momentMonth = momentDate.format("MM"),
        momentYear = momentDate.format("YYYY"),
        momentHours = momentDate.format("HH"),
        momentMinutes = momentDate.format("mm"),
        momentSeconds = momentDate.format("ss");
      // let time = momentYear+'-'+momentMonth+'-'+momentDay+' '+momentHours+':'+momentMinutes+':'+momentSeconds;

      var t =
        '"' +
        momentYear +
        "-" +
        momentMonth +
        "-" +
        momentDay +
        " " +
        momentHours +
        ":" +
        momentMinutes +
        '"';
      var cdt = moment(t, "YYYY-MM-DD HH:mm");
      // console.log(cdt.toDate());
      return cdt.toDate();
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
    formatDateRefresh(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
    formatDay(value) {
      let timestamp = { seconds: value, nanoseconds: 0 }; // firebase data
      let myDate = new Date(timestamp.seconds * 1000); // date object
      return myDate;
    },
    formatDay(value) {
      return moment(value).format("dddd");
    },
    toFixed(value) {
      return value.toFixed(0);
    },
  },
  beforeMount() {
    this.getUserBasicInfo();
    this.getUserBasicInfo2();
    this.getPreferences();
    this.getPreferencesUserInfo();
    this.getPreferencesUserInfo2();
    this.getPreferencesAvatar();
    this.getPreferencesRapidUserPost();
    this.getPreferencesRapidUserPost2();
    this.getPreferencesRapidFollowers();
    this.getPreferencesRapidFollowers2();
    this.getPreferencesRapidFollowing();
    this.getPreferencesRapidFollowing2();
    this.getPreferencesRapidUserTag();
    this.getPreferencesRapidUserTag2();
    this.getPreferencesRapidUserSimiliar();
  },
  mounted() {
    this.totalRows = this.items.length;
    this.$gmapApiPromiseLazy().then(() => {
      if (this.google) {
        this.geocoder = new this.google.maps.Geocoder();
      }
    });
  },
};
</script>

<style scoped>
/* .card{
  border: 2px solid #f1f1f1;
} */
.my-custom-scrollbar {
  position: relative;
  height: 500px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>